import i18n from '@newspaces/zero-base/i18n';
export { default } from '@newspaces/zero-base/i18n';

const enLanguage = {
  misc: {
    unknown: "Unknown"
  },
  accessCommands: {
    PING: {
      label: "Ping device",
      hint: "Ping a device to see if its available and connectable"
    },
    BOOTLD: {
      label: "Install new application",
      hint: "Allows to install a new application version on device"
    },
    STATUS: {
      label: "Get system status",
      hint: "Gets the system status of a device and send it to backend"
    },
    TIME: {
      label: "Get the time",
      hint: "Gets the system time on a device"
    },
    TIME_SET: {
      label: "Set the time",
      hint: "Set a new time on a device"
    },
    UPDATE: {
      label: "Update system configuration",
      hint: "Update the system configuration including changing keys"
    },
    DEFAULTS: {
      label: "Reset device",
      hint: "Clear all settings, configuration and stored data from a device"
    },
    RESET: {
      label: "Restart device",
      hint: "Restarts the device"
    },
    FACTORY: {
      label: "Reset to factory",
      hint: "Delete all and reset to factory to be able to reprovision the device"
    },
    PROVI: {
      label: "Apply new provision",
      hint: "Allows to reprovision the device to supply new secret keys"
    },
    BL_CLEAR: {
      label: "Clear blacklist",
      hint: "Allows to clear the whole blacklist of a device"
    },
    BL_PUSH: {
      label: "Add to blacklist",
      hint: "Allows to push new entries to the blacklist"
    },
    SL_CLEAR: {
      label: "Clear system-log",
      hint: "Allows to clear the whole system-log of a device"
    },
    SL_QUERY: {
      label: "Query system-log",
      hint: "Allows to query the system-log of a device"
    },
    EV_CLEAR: {
      label: "Clear event-log",
      hint: "Allows to clear the whole event-log of a device"
    },
    EV_QUERY: {
      label: "Query event-log",
      hint: "Allows to query the event log of a device"
    },
    ACC_DEF: {
      label: "Access with default time",
      hint: "Equal to default access type"
    },
    ACC_EXT: {
      label: "Access with extended time",
      hint: "Equal to extended access type"
    },
    ACC_CST: {
      label: "Access with custom time",
      hint: "Allows to access with a custom user defined time"
    },
    ACC_TGL: {
      label: "Access with toggle mode",
      hint: "Equal to toggle access type"
    },
    ACC_CLS: {
      label: "Access to close",
      hint: "Allows access to close the device"
    },
    UZ_BTCHG: {
      label: "Battery Change Mode",
      hint: "Battery change position, cover can be removed"
    },
    UZ_DMNT: {
      label: "Disassembly Mode",
      hint: "Dismount position, lock can get removed from the door"
    }
  },
  accessCredential: {
    modelName: {
      single: "Access credential",
      multi: "Access credentials"
    },
    shortName: " ${this.credentialType} Credential",
    site: "Site",
    credentialId: "Id",
    credentialType: "Type",
    credentialTypeValue: {
      regular: "Regular",
      regularInfo: "Regular credential can only open / enter",
      maintenance: "Maintenance",
      maintenanceInfo: "Maintenance can open and update all locks within the site",
      master: "Master",
      masterInfo: "Master can open all locks within the given site",
      nfcWriter: "Nfc Writer",
      nfcWriterInfo: "Nfc writer allows to write any credential within this site on cards & fobs",
      emergency: "Emergency",
      emergencyInfo: "Emergency can open all locks within the given site, has no validity and requires no refresh"
    },
    identity: "Identity",
    receiver: "Receiver",
    status: "Status",
    statusValue: {
      pending: "Pending",
      available: "Available",
      sent: "Sent",
      activated: "Activated",
      expired: "Expired",
      revoked: "Revoked"
    },
    name: "Name",
    description: "Description",
    validity: "Validity",
    noValidity: "Not used yet",
    sentAt: "Sent at",
    activatedAt: "Activated at",
    refreshedAt: "Refreshed at",
    revokedAt: "Revoked at",
    revokedBy: "Revoked by",
    createdAt: "Created at",
    validFrom: "Valid from",
    validFromInfo: "Defines when the access becomes active, leave empty for immmediately",
    validTo: "Valid until",
    validToInfo: "When no longer valid the access will be denied, leave empty to not have any validity ending",
    refresh: "Refresh",
    refreshInfo: "If set defines the number of days after an access expires and requires a refresh. This should not be too long to ensure access can be revoked easily.",
    access: "Access",
    accessCount: {
      single: "${this.count} Access",
      multi: "${this.count} Accesses"
    },
    accessCredentialAccess: {
      target: "Target",
      targetValue: {
        group: "Group",
        object: "Object"
      },
      isSchedule: "Scheduled",
      isScheduleInfo: "If set, this item's access privileges are limited to the schedule(s) specified below in the Schedules section.",
      type: "Type",
      typeValue: {
        default: "Default",
        extended: "Extended",
        toggle: "Toggle"
      }
    },
    accessSchedules: "Schedules",
    accessSchedulesCount: {
      single: "${this.count} Schedule",
      multi: "${this.count} Schedules"
    },
    accessSchedulesInfo: "Schedules limit the validity of the credential to certain days and/or time ranges per day. The schedule is individually applied per group/object if the checkbox \u201CScheduled\u201D is checked. Groups/objects without an active checkbox will open without restrictions.",
    accessCredentialReceiver: {
      name: "Name",
      mobilePhone: "Mobile Phone",
      email: "E-Mail"
    },
    mergeTags: {
      name: "Name",
      description: "Description",
      receiverName: "Receiver Name"
    }
  },
  accessDevice: {
    modelName: {
      single: "Device",
      multi: "Devices"
    },
    status: "Status",
    statusValue: {
      created: "Created",
      claimed: "Claimed",
      active: "Active",
      requireUpdate: "Requires update",
      disabled: "Disabled"
    },
    deviceId: "Device Id",
    site: "Site",
    object: "Object",
    name: "Name",
    description: "Description",
    hardware: "Hardware",
    accessDeviceHardware: {
      type: "Type",
      version: "Version",
      serialNumber: "Serial-No",
      name: "Name",
      vendorName: "Vendor",
      vendorMeta: "Custom data",
      hardwareTypeValues: {
        0: "Unknown Hardware",
        1: "Test Hardware",
        2: "Gateway",
        3: "Cylinder Lock",
        4: "Door Handle Lock",
        5: "Wall Reader",
        6: "Kiosk"
      }
    },
    systemStatus: "System status",
    accessDeviceSystemStatus: {
      batteryLevel: "Battery",
      batteryLevelValue: {
        0: "Unknown",
        1: "On power",
        10: "Good",
        11: "Low",
        12: "Critical",
        13: "Almost empty"
      },
      applicationVersion: "Firmware",
      applicationTestVersion: "Firmware (Test Version)",
      localTime: "Local time",
      blacklistMaxEntriesCount: "Blacklist max",
      blacklistEntriesCount: "Blacklist stored",
      eventLogMaxEntriesCount: "Events max",
      eventLogEntriesCount: "Events stored",
      systemLogMaxEntriesCount: "System-Log max",
      systemLogEntriesCount: "System-Log stored",
      hardwareType: "Hardware type",
      lockState: "Lock state",
      lockStateValues: {
        1: "Unknown",
        2: "Locked",
        3: "Unlocked",
        4: "Jammed"
      }
    },
    systemStatusUpdatedAt: "Last update",
    createdAt: "Created"
  },
  accessGroup: {
    modelName: {
      single: "Group",
      multi: "Groups"
    },
    sites: "Sites",
    groupId: "Id",
    name: "Name",
    description: "Description",
    accessPlan: "Access plan",
    createdAt: "Created at",
    accessSchedules: "Schedules",
    accessSchedulesInfo: "When you set a schedule, each lock in the group is only accessible during the specified time. Access outside of these hours is prohibited unless an Emergency Key is detected.",
    accessSchedulesAllTime: "All time access"
  },
  accessObject: {
    modelName: {
      single: "Object",
      multi: "Objects"
    },
    site: "Site",
    objectId: "Id",
    configuration: "Configuration",
    groups: "Groups",
    devices: "Devices",
    name: "Name",
    description: "Description",
    createdAt: "Created at"
  },
  accessObjectEvent: {
    eventId: "Event",
    eventIdValues: {
      1: "Battery Low",
      2: "Battery Replaced",
      3: "Lock Jammed",
      4: "System Event",
      5: "Internal Error",
      6: "Failed to Unlock",
      7: "Tampering Detected",
      8: "Blacklisted Credential Detected",
      9: "Blacklist Full",
      10: "Access Granted",
      11: "Access Denied",
      12: "CRC Error",
      13: "Max OssSo EventId",
      14: "Terminal Command",
      15: "TerminalOss"
    },
    eventInfoValues: {
      system: {
        1: "System Restared",
        2: "System Configured"
      },
      access: {
        1: "Granted",
        2: "Granted Default Time",
        3: "Granted Extended Time",
        4: "Granted Toggle Unlock",
        5: "Granted Toggle Lock",
        128: "Denied",
        130: "Denied Blacklisted",
        131: "Denied Validity",
        132: "Denied DT Schedule"
      }
    }
  },
  accessDeviceLogEntry: {
    severity: "Severity",
    severityValues: {
      1: "Error",
      2: "Warning",
      3: "Info",
      4: "Debug"
    }
  },
  accessSite: {
    modelName: {
      single: "Site",
      multi: "Sites"
    },
    name: "Name",
    description: "Description",
    siteId: "Id",
    createdAt: "Created at",
    location: "Location",
    locationInfo: "The location defines the timezone, daylight savings and holidays",
    credentialMode: "Credential mode",
    credentialModeInfo: "The credential mode defines how the credential is sent to the user",
    credentialModeValues: {
      blueidApp: "BlueID App",
      customApp: "Custom App",
      apiOnly: "API Only"
    },
    customActivationUrl: "Activation URL",
    customActivationUrlInfo: "URL used to activate credentials of custom apps. Use the {{activationToken}} placeholder to insert the activation token.",
    mergeTags: {
      name: "Name"
    }
  },
  accessConfiguration: {
    modelName: {
      single: "Configuration",
      multi: "Configurations"
    },
    settings: {
      base: {
        label: "Base settings"
      },
      ble: {
        label: "Bluetooth settings",
        isAdvertising: "Active",
        isAdvertisingInfo: "Enables Bluetooth. If any schedule is set then it will only be active during the given times",
        advertisingSchedules: "Schedules",
        advertisingSchedulesInfo: "Multiple schedules when Bluetooth should be active or when it should send on high power",
        advertisingHighPower: "If set will send with maximum power for the given time ie to reach gateways. Be careful as the longer this happens the faster batteries will drain.",
        advertisingIntervalMs: "Activity interval",
        advertisingIntervalMsInfo: "The actual advertising interval in milliseconds. The larger the longer connections and finding takes but battery power is saved. For on-power devices 100ms is adviced for battery-powered ones it should be 500ms",
        maxConnectionTimeoutMs: "Connection Time",
        maxConnectionTimeoutMsInfo: "The time in milliseconds until a connection is dropped between a device and an user. For security purposes this should not be too high but not too low either to compensate for noisy environments",
        txPowerLevel: "Power level",
        txPowerLevelInfo: "The power level the device is sending with. The lower the closer one needs to be and the more battery is saved",
        advertisedTxPower1Meter: "Power on 1-Meter",
        advertisedTxPower1MeterInfo: "The advertised power for 1-meter distance in decibels. Should be measured per device for proper distance measurement.",
        isIBeaconAdvertisement: "Is iBeacon",
        isIBeaconAdvertisementInfo: "If set will advertise in IBeacon format. This allows Nearby-Mode to be usable on iOS devices"
      },
      online: {
        label: "Online settings",
        connectSchedules: "Schedules",
        connectSchedulesInfo: "The Schedules when to connect online and update data. On always-powered devices this is ignored, for battery-powered devices it is advised to do it only once a day to save battery. The end-time is ignored.",
        wifiSSID: "Wifi SSID",
        wifiPassword: "Wifi Password",
        timeoutSec: "Timeout",
        timeoutSecInfo: "Timeout in seconds when the connection is stopped ie if server is not reached to save battery and computing power"
      },
      ossSo: {
        label: "Offline card settings",
        updater: "Update card",
        updaterInfo: "If set and device is online, will try to get new access grants for a given card and update it before letting user enter",
        pushEvents: "Push events",
        pushEventsInfo: "If set and device is online, will try to read any events from a card and push them to the system and clear the card events before letting user enter",
        writePendingEvents: "Write events",
        writePendingEventsInfo: "If set, writes pending events from the device into the card before letting the user enter so they can be read somewhere else and pushed to the system",
        updateFromBlacklist: "Update blacklist",
        updateFromBlacklistInfo: "If set will read any blacklist stored on card and update the internal blacklist with it"
      },
      lock: {
        label: "Lock",
        openSchedules: "Open Schedules",
        openSchedulesInfo: "Optional schedules when the lock should be automatically opened at",
        openScheduleByUser: "Open by user",
        keepClosedOnHolidays: "Holidays closed",
        keepClosedOnHolidaysInfo: "If set will not auto-open on federal vacation days at the objects location",
        openScheduleByUserInfo: "If set, the schedules only open after the first user interaction, otherwise they open automatically",
        defaultOpenTimeSec: "Default time",
        defaultOpenTimeSecInfo: "Default time in seconds on how long the lock stays opened after user entered with default access",
        extendedOpenTimeSec: "Extended time",
        extendedOpenTimeSecInfo: "Extended time in seconds on how long the lock stays opened after user entered with extended access"
      }
    },
    name: "Name",
    description: "Description",
    sites: "Sites",
    sitesInfo: "Limit to be available on the given sites only. Leave empty to make it available to any site",
    createdAt: "Created at"
  },
  accessMessageTemplate: {
    modelName: {
      single: "Message Template",
      multi: "Message Templates"
    },
    type: "Template",
    typeValues: {
      credential: "Credential claim"
    },
    language: "Language",
    method: "Send method",
    methodValues: {
      email: "E-Mail",
      sms: "SMS"
    },
    subject: "Subject",
    content: "Message"
  },
  identity: {
    modelName: {
      single: "Identity",
      multi: "Identities"
    },
    modelNameUser: {
      single: "User",
      multi: "Users"
    },
    type: "Type",
    typeValue: {
      other: "Other",
      device: "Device",
      user: "User",
      person: "Person"
    },
    identity: "Identity",
    status: "Status",
    statusValue: {
      invited: "Invited",
      created: "Created",
      inactive: "Inactive",
      active: "Active",
      blocked: "Blocked"
    },
    name: "Name",
    description: "Description",
    refresh: "Refresh",
    createdAt: "Created",
    lastSeenAt: "Last seen",
    lastLoginAt: "Last login",
    numberOfLogins: "Logins",
    loginsPerApp: "App logins",
    signedUpAt: "Signed up",
    // Specific object related
    object: {
      user: {
        name: "Name",
        primaryMail: "E-Mail",
        connections: "Connections",
        claims: "Claims",
        mfaMethods: "MFA Methods"
      },
      person: {
        mobilePhone: "Mobile Phone",
        email: "E-Mail"
      }
    },
    access: {
      title: "Access",
      sites: "Sites"
    },
    mergeTags: {
      name: "Name"
    }
  },
  mergeTags: {
    other: {
      label: "Special Placeholders",
      emailVerificationUrl: "Email Verification URL",
      resetPasswordUrl: "Reset Password URL",
      credentialClaimUrl: "Credential Claim URL",
      tempPassword: "Temporary Password",
      email: "E-Mail"
    }
  },
  baseConnector: {
    modelName: {
      single: "Connector",
      multi: "Connectors"
    },
    mergeTags: {
      name: "Name"
    }
  },
  connectors: {
    name: "Name",
    nameHint: "Name of the connector",
    google: {
      clientId: "Client ID",
      clientIdHint: "The Google OAuth client id",
      clientSecret: "Client Secret",
      clientSecretHint: "The Google OAuth client secret",
      scopes: "Scopes",
      scopesHint: "The scopes to be requested from Google",
      syncOnLogin: "Sync on Login",
      syncOnLoginHint: "If set to true the user will be synced on login"
    },
    microsoft: {
      clientId: "Client ID",
      clientIdHint: "The Microsoft OAuth client id",
      clientSecret: "Client Secret",
      clientSecretHint: "The Microsoft OAuth client secret",
      scopes: "Scopes",
      scopesHint: "The scopes to be requested from Microsoft",
      commonIssuer: "Allow work and school accounts",
      commonIssuerHint: "If set to true users are allowed to login with work and school accounts",
      syncOnLogin: "Sync on Login",
      syncOnLoginHint: "If set to true the user will be synced on login"
    },
    facebook: {
      clientId: "Client ID",
      clientIdHint: "The Facebook OAuth client id",
      clientSecret: "Client Secret",
      clientSecretHint: "The Facebook OAuth client secret",
      scopes: "Scopes",
      scopesHint: "The scopes to be requested from Facebook",
      syncOnLogin: "Sync on Login",
      syncOnLoginHint: "If set to true the user will be synced on login"
    },
    azureAD: {
      clientId: "Client ID",
      clientIdHint: "The Entra ID OAuth client id",
      clientSecret: "Client Secret",
      clientSecretHint: "The Entra ID OAuth client secret",
      multiTenant: "Multi-Tenant",
      multiTenantHint: "If enabled users from any tenant can login. You must configure the app registration accordingly in Azure.",
      tenantDomain: "Tenant Domain",
      tenantDomainHint: "The Entra ID tenant domain",
      loadExtendedProfile: "Load Extended Profile",
      loadExtendedProfileHint: "If set to true additional user information will be loaded",
      loadGroups: "Load Groups",
      loadGroupsHint: "If set to true the groups the user is member of will be loaded",
      maxGroups: "Max. Groups",
      maxGroupsHint: "The maximum number of groups to load",
      scopes: "Scopes",
      scopesHint: "The scopes to be requested from Entra ID",
      syncOnLogin: "Sync on Login",
      syncOnLoginHint: "If set to true the user will be synced on login",
      forceEmailVerified: 'Always set email_verified to "true"',
      forceEmailVerifiedHint: "If set to true the email_verified claim will always be set to true"
    },
    database: {
      hasUserName: "Requires Username",
      hasUserNameHint: "If set a user is required to provide a username on signup",
      disableSignups: "Disable Sign Ups",
      disableSignupsHint: "If set, only login is possible with this provider but no sign-ups",
      confirmSignupMail: "Confirm Signup E-Mail",
      confirmSignupMailValues: {
        disabled: "Disabled",
        blocking: "Required",
        nonBlocking: "Optional"
      },
      confirmSignupMailHints: {
        disabled: "<<Disabled>> - Verification is not requested",
        blocking: "<<Required>> - Verification is requested and required for signing up",
        nonBlocking: "<<Optional>> - Verification is requested but not required"
      },
      confirmSignupMailHint: `Email verification requirement`,
      allowUnverifiedLoginBefore: "Allow Unverified Login Before",
      allowUnverifiedLoginBeforeHint: "Allow users that received the last verification email before this date to login without verification. This can be used in the transition between a system without email verification and one with it.",
      unverifiedLoginTimout: "Unverified Login Time Allowed",
      unverifiedLoginTimoutHint: "The time in days an unverified user can login after the last verification email was sent. <<Warning:>> Users can resend the verification email at any time and extend the period they are allowed to log in indefinitely. Set to 0 to block unverified users immediately.",
      emailVerificationTimeout: "Email Verification Timeout",
      emailVerificationTimeoutHint: "The time in minutes an email verification token is valid. <<0 means it never expires>>.",
      passwordStrength: "Password Strength",
      passwordStrengthValues: {
        none: "None",
        low: "Low",
        fair: "Fair",
        good: "Good",
        excellent: "Excellent"
      },
      passwordStrengthValueHints: {
        none: "Non-empty password required",
        low: "Must have ${this.passwordStrength} characters in length",
        fair: "Lower case (a-z), upper case (A-Z) and numbers (0-9)",
        good: "Special characters (!@#$%^&*)",
        excellent: "No more than 2 identical characters in a row"
      },
      passwordMinLength: "Min. Password Length",
      passwordHistoryHint: "If set will store the users password history and avoid re-using any of them",
      passwordDictionaryHint: "If set disables the use of the most common password words",
      passwordNoPersonalDataHint: "If set, prevents the user from using any of his personal data in passwords",
      passwordConfirmationHint: "If set, users are required to confirm their password",
      passwordResetTimeout: "Password Reset Timeout",
      passwordResetTimeoutHint: "The time in minutes a password reset token is valid",
      mfaMode: "Multi-Factor Authentication Mode",
      mfaModeHint: "The MFA-Mode for signin in",
      mfaModeValues: {
        none: "None",
        user: "Optional",
        forced: "Required"
      },
      mfaModeValueHints: {
        none: "<<None>> - No MFA available",
        user: "<<Optional>> - User can optionally activate MFA for his account",
        forced: "<<Required>> - User is enforced to use MFA"
      },
      mfaOnSignup: "MFA on Signup",
      mfaOnSignupHint: "If set, the user is prompted to setup MFA during signup",
      captchaMethod: "Method",
      captchaMethodHint: "The CAPTCHA method to use",
      captchaMethodValues: {
        none: "None",
        recaptchaV3: "reCAPTCHA v3"
      },
      captchaKey: "Key",
      captchaKeyHint: "The reCAPTCHA site key",
      captchaSecret: "Secret",
      captchaSecretHint: "The reCAPTCHA secret key",
      captchaMinScore: "Min. Score",
      captchaMinScoreHint: "The minimum score required for the CAPTCHA to pass",
      loginValidationEndpoint: "Login Validation Endpoint",
      loginValidationEndpointHint: "Custom endpoint to validate user credentials. This is used to convert from old systems",
      loginConfirmationEndpoint: "Login Confirmation Endpoint",
      loginConfirmationEndpointHint: "Custom endpoint to confirm user login. This is used to convert from old systems",
      migrationAuthMethod: "Migration Auth Method",
      migrationAuthMethodHint: "The authentication method to use for migration",
      migrationAuthMethodValues: {
        none: "None",
        selfAuth: "Self Authentication",
        apiKey: "API Key",
        jwt: "JWT"
      },
      migrationApiKeyPrefix: "Migration API Key Prefix",
      migrationApiKeyPrefixHint: "The prefix to use for the migration api key",
      migrationApiKey: "Migration API Key",
      migrationApiKeyHint: "The api key to use for migration",
      createIdentityWithMigrationId: "Create Identity With Migration Id",
      createIdentityWithMigrationIdHint: "If set, the id of the migrated user will be used to create the identity"
    }
  },
  authMessageTemplate: {
    modelName: {
      single: "Message Template",
      multi: "Message Templates"
    },
    language: "Language",
    typeValues: {
      emailVerification: "Verification Email",
      passwordReset: "Password Reset Email",
      afterSignup: "Welcome Email",
      activation: "Account Activation Email"
    }
  },
  organisation: {
    modelName: {
      single: "Organisation",
      multi: "Organisations"
    },
    avatar: "Logo",
    mergeTags: {
      name: "Name",
      logo: "Logo"
    }
  },
  authTenant: {
    modelName: {
      single: "Tenant",
      multi: "Tenants"
    },
    avatar: "Logo",
    connectors: {
      single: "Connection",
      multi: "Connections"
    },
    connectorsValues: {
      database: "Database",
      google: "Google",
      microsoft: "Microsoft",
      azureAD: "Entra ID",
      facebook: "Facebook"
    },
    disabled: "Disable tenant",
    enableAdminInterface: "Enable Admin Interface",
    enableAdminInterfaceHint: "When activated, this option grants users the ability to independently manage their accounts directly through the admin interface, offering greater autonomy and control over account-related tasks.",
    settings: {
      defaultLanguage: "Default language",
      defaultLanguageHint: "The default language to be used for any UI, error and mail handling",
      defaultCountry: "Default country",
      defaultCountryHint: "The country defines how dates and times are formatted in the UI and mails",
      persistentSession: "Persistent Session",
      persistentSessionHint: "While the session cookie is active, users will be automatically logged in when redirected to BlueID.",
      requireLoginAfter: "User Session Timeout",
      requireLoginAfterHint: "The User Session Timeout defines the duration, in minutes, that a user session remains active. When the refresh option is enabled, the session automatically extends with each user interaction, ensuring a seamless and uninterrupted experience. If the refresh option is disabled, the user will need to re-authenticate once the session timeout is reached.",
      refreshSessionExpiration: "Refresh Session Expiration",
      refreshSessionExpirationHint: "The Refresh Session Expiration option, when enabled, refreshes the session expiration time every time the user is redirected to BlueID. This feature provides users with the convenience of extending their session duration without the need to manually log in again. If disabled, users will be prompted to log in once the original session expiration time is reached.",
      enableBackchannelLogout: "Enable Backchannel Logout",
      enableBackchannelLogoutHint: "Enabling the Backchannel Logout option triggers a call to the specified backchannel URL after a user logs out. This feature serves to notify the associated application that the user has completed the logout process, allowing the application to perform any necessary post-logout actions. It's essential to configure the <<Backchannel Logout URL>> in the <<Application Settings>> to ensure the seamless functioning of this mechanism.",
      inactivityTimeout: "Inactivity Timeout",
      inactivityTimeoutHint: "Max. time in minutes the user can be inactive before he gets forced to re-login",
      interactionTimeout: "Interaction Session Timeout",
      interactionTimeoutHint: "The Interaction Session Timeout sets the maximum time, in minutes, that a user has to interact with the login/signup page. Once the interaction timeout is reached, users may need to restart the login/signup process to ensure the security and integrity of the authentication flow.",
      defaultAccessTokenTimeout: "Access Token Timeout",
      defaultAccessTokenTimeoutHint: "The Access Token Timeout defines the period of validity for the access token granted to a user after successful authentication. Once this time limit is reached, the access token expires, requiring the user to re-authenticate to regain access to protected resources.",
      defaultRefreshTokenTimeout: "Refresh Token Timeout",
      defaultRefreshTokenTimeoutHint: "The Refresh Token Timeout sets the duration during which a refresh token remains valid. Refresh tokens are used to obtain new access tokens without requiring the user to re-enter their credentials. After the refresh token timeout elapses, users must be redirected to BlueID to obtain a new set of tokens.",
      defaultClientCredentialsTimeout: "Client Credentials Token Timeout",
      defaultClientCredentialsTimeoutHint: "The Client Credentials Token Timeout specifies the duration of validity for tokens generated using the client_id and client_secret. These tokens are utilized by client applications to authenticate with the authorization server. Once the client credentials token timeout elapses, the client application needs to obtain new tokens by re-authenticating with the authorization server using its client credentials.",
      idTokenTimeout: "ID Token Timeout",
      idTokenTimeoutHint: "The ID Token Timeout specifies how long the identity token, containing user information, remains valid. ID tokens are typically used to convey user identity information to the client application. Once the ID token timeout expires, the application may need to re-authenticate the user to obtain a fresh ID token.",
      authCodeTimeout: "Auth Code Timeout",
      authCodeTimeoutHint: "The Auth Code Timeout sets the duration for which the authorization code remains valid. After a user successfully authorizes a client application, an authorization code is issued, allowing the application to exchange it for access tokens. The auth code timeout ensures that the code is used promptly and is not susceptible to unauthorized use if intercepted.",
      scopes: {
        name: "Name",
        claims: "Claims",
        description: "Description"
      },
      responseTypes: "Response Types",
      responseTypesHint: "These are the response types supported by the tenant. Applications associated with this tenant will only have access to response types explicitly listed here.",
      responseTypeValues: {
        code: "Code",
        id_token: "ID Token",
        "id_token token": "ID Token, Token",
        "code id_token": "Code, ID Token",
        "code token": "Code, Token",
        "code id_token token": "Code, ID Token, Token",
        none: "None"
      },
      additionalClaims: "Additional Claims",
      oauthResourcesClaims: "Auth Resources",
      oauthResourcesClaimsHint: "The resources available for the tenant",
      showLogoutPrompt: "Show Logout Prompt",
      showLogoutPromptHint: "When the Show Logout Prompt option is enabled, users will be prompted to confirm their decision to log out. This additional step adds a layer of security and ensures that users are intentional about ending their session. By confirming the logout, users help prevent accidental logouts and maintain control over their account security.",
      allowAuthTroughIframe: "Allow Authentication from Iframe",
      allowAuthTroughIframeHint: "Enabling this feature allows integration of BlueID within an iframe, facilitating authentication processes directly within designated web pages.",
      blockUserClaimManagement: "Block User Claim Management",
      blockUserClaimManagementHint: "If this option is enabled, users will not be able to manage their claims. Only security settings will be available from the admin interface."
    },
    signingKeys: {
      status: "Status",
      statusValues: {
        next: "Next in Queue",
        current: "Currently used",
        previous: "Previous",
        revoked: "Revoked"
      },
      keyId: "Key ID",
      revokedAt: "Revoked on",
      public: "Public Key"
    },
    issuer: "Issuer URL",
    issuerHint: "The issuer URL uniquely identifies the authorization server.",
    mergeTags: {
      name: "Name",
      logo: "Logo"
    }
  },
  organisationUser: {
    modelName: {
      single: "User",
      multi: "Users"
    }
  },
  authApplication: {
    modelName: {
      single: "Application",
      multi: "Applications"
    },
    name: "Name",
    logo: "Application Logo",
    logoHint: "An image that identifies the application",
    description: "Description",
    descriptionHint: "A free text description of the application.",
    type: "Type",
    typeHint: "The type of application will determine the behavior of the authentication server.",
    typeValue: {
      spa: "Single Page Application",
      native: "Native",
      web: "Regular Web Application",
      machine: "Machine to Machine"
    },
    clientId: "Client ID",
    clientSecret: "Client Secret",
    responseTypes: "Response Types",
    responseTypesHint: "The response types that can be used by the application",
    responseTypeValues: {
      code: "Code",
      id_token: "ID Token",
      "id_token token": "ID Token, Token",
      "code id_token": "Code, ID Token",
      "code token": "Code, Token",
      "code id_token token": "Code, ID Token, Token",
      none: "None"
    },
    grantTypes: "Grant Types",
    grantTypesHint: "The grant types that the application is allowed to use to authenticate the users",
    grantTypeValues: {
      implicit: "Implicit",
      authorization_code: "Authorization Code",
      refresh_token: "Refresh Token",
      client_credentials: "Client Credentials"
    },
    tokenEndpointAuthMethod: "Token Endpoint Auth Method",
    tokenEndpointAuthMethodHint: "The authentication method used for the token endpoint",
    tokenEndpointAuthMethodValue: {
      none: "None"
    },
    callbackUrls: "Allowed Callback URLs",
    callbackUrlsHint: "After the user authenticates we will only call back to any of these URLs. You can specify multiple valid URLs by comma-separating them (typically to handle different environments like QA or testing). Make sure to specify the protocol (<<https://>>) otherwise the callback may fail in some cases. With the exception of custom URI schemes for native clients, all callbacks should use protocol <<https://>>.",
    logoutUrls: "Allowed Logout URLs",
    logoutUrlsHint: "A set of URLs that are valid to redirect to after logout from BlueID. After a user logs out from BlueID you can redirect them with the <<post_logout_redirect_uri>> query parameter. The URL that you use in <<post_logout_redirect_uri>> must be listed here. You can specify multiple valid URLs by comma-separating them. Query strings and hash information are not taken into account when validating these URLs.",
    backchannelLogoutUrl: "Backchannel Logout URL",
    backchannelLogoutUrlHint: "A URL that will be called after logout with the details of the user that disconnected. This is used to notify the application that the user has logged out and to perform any actions required. Be sure to check <<Enable Backchannel Logout>> in the <<Tenant Settings>> for this to work.",
    appLoginUrl: "Application Login URL",
    appLoginUrlHint: "In some scenarios, BlueID will need to redirect to your application's login page. This URL needs to point to a route in your application that should redirect to your tenant's <</auth>> endpoint.",
    allowedCorsOrigins: "Allowed Origins (CORS)",
    allowedCorsOriginsHint: "List of origins allowed to make cross-origin resource sharing (CORS) requests.",
    allowedCorsOriginsHints: {
      1: "URLs can be comma-separated or added line-by-line",
      2: "Use wildcards (*) at the subdomain level (e.g. https://*.contoso.com)",
      3: "Query strings and hash information are ignored"
    },
    identitySyncUrl: "Identity Sync URL",
    identitySyncUrlHint: "A URL that will be called to synchronize the user's information with the application whenever a change is made to the user. A JWT token populated with the modified fields will be sent to this URL.",
    disabledConnectors: "Disabled Token Endpoint Auth Method",
    revocationEndpointAuthMethod: "Revocation Endpoint Auth Method",
    revocationEndpointAuthMethodHint: "The authentication method used for the revocation endpoint",
    introspectionEndpointAuthMethod: "Introspection Endpoint Auth Method",
    introspectionEndpointAuthMethodHint: "The authentication method used for the introspection endpoint",
    metaEntries: {
      property: "Metadata Entries",
      key: "Key",
      value: "Value"
    },
    oidcMetadata: "OIDC Metadata",
    endpointAuthMethodsValues: {
      client_secret_basic: "Client Secret Basic",
      client_secret_jwt: "Client Secret JWT",
      client_secret_post: "Client Secret Post",
      private_key_jwt: "Private JWT Key",
      none: "None"
    },
    pkceRequired: "PKCE Required",
    pkceRequiredHint: "If set to true PKCE is required for the Authorization Code Flow",
    thirdParty: "Is Application Third Party",
    thirdPartyHint: "If set to true the application is a third party application and user consent will always be requested before granting access",
    signupAgreements: "Signup Agreements",
    signupAgreementsHint: "The agreements you create here will be shown in the signup page in the order you specify. The user has to accept all of them to be able to create an account. You can use Markdown to add links and format the text.",
    mergeTags: {
      name: "Name",
      clientId: "Client ID",
      logo: "Logo",
      loginUrl: "Login URL"
    }
  },
  authFlows: {
    base: {
      passwordRequirements: {
        title: "Your password must contain:",
        nonEmpty: "At least one character",
        minLength: "At least ${this.connectors.database.passwordMinLength} characters",
        lowercase: "At least one lowercase character (a-z)",
        uppercase: "At least one uppercase character (A-Z)",
        number: "At least one number (0-9)",
        specialChar: "At least one special character (e.g. !@#$%^&*)",
        noDuplication: "No more than 2 identical characters in a row"
      },
      emailVerificationRequired: {
        title: "Confirm your email address",
        subtitle: "To access your account we must verify your email address. An email with instructions on how to proceed was sent to you",
        resendEmailButton: "Resend email",
        emailAlreadyVerified: "Your email address has already been verified",
        unableToSendEmail: "The email could not be sent. Please try again later"
      },
      status: {
        backButton: "Back to ${this.app.name}"
      },
      errors: {
        default: "Something went wrong"
      }
    },
    login: {
      title: "Login",
      credentials: {
        title: "Welcome to ${this.app.name}!",
        subtitle: "Log in with your email and password",
        emailLabel: "Email",
        passwordLabel: "Password",
        resetPasswordLink: "Forgot password?",
        continueButton: "Continue",
        alternateLoginOptions: "Or login with",
        signupPreMessage: "Not a member?",
        signupLink: "Sign up now"
      },
      mfa: {
        title: "2-Step Verification",
        subtitle: "To enhance the security of your account, you've enabled two-factor authentication. Please enter the 6-digit code from your mobile device's authenticator app. This code ensures that only you can access your account.",
        codeLabel: "Enter code",
        continueButton: "Continue"
      },
      activationPassword: {
        title: "Set Up Your Password",
        subtitle: "Please set up a new password to secure your account",
        passwordLabel: "Password",
        confirmPasswordLabel: "Confirm password",
        continueButton: "Continue",
        cancelButton: "Cancel"
      },
      errors: {
        missingParameters: "",
        incorrectCredentials: "The email or password is incorrect",
        accountBlocked: "Your account has been blocked",
        missingInformation: "",
        invalidOtpCode: "Invalid code",
        invalidEmail: "Invalid email",
        invalidPassword: "Invalid password"
      }
    },
    signup: {
      title: "Sign Up",
      credentials: {
        title: "Sign Up",
        subtitle: "Create an account with your email and password",
        emailLabel: "Email",
        passwordLabel: "Password",
        confirmPasswordLabel: "Confirm password",
        continueButton: "Continue",
        loginPreMessage: "Already have an account?",
        loginLink: "Log in"
      },
      mfa: {
        title: "Secure Your Account",
        subtitle: "Select the 2-factor authentication method you want to use to secure your account",
        continueButton: "Continue",
        totp: {
          buttonLabel: "Verification app (TOTP)",
          buttonDescription: "Scan a QR Code with a verification app and enter the one-time code to verify your identity",
          title: "Set up verification app",
          subtitle: "Scan the QR Code below using your preferred authenticator app and then enter the provided one-time code below",
          codeLabel: "Enter code",
          continueButton: "Continue",
          cancelButton: "Cancel"
        }
      },
      errors: {
        invalidSession: "",
        unableToSendEmail: "",
        signupDenied: "Signup is disabled for this application",
        missingParameters: "",
        missingAgreements: "You must accept all agreements",
        passwordMismatch: "Password do not match",
        emailAlreadyTaken: "Email already in use",
        invalidEmail: "Invalid email",
        invalidPassword: "Invalid password",
        invalidAction: "",
        invalidOtpCode: "Invalid code",
        captchaFailed: "We couldn't verify that you are a human. Try again in a few seconds"
      }
    },
    consent: {
      title: "Authorize App",
      main: {
        title: "Authorize App",
        subtitle: "${this.app.name} is requesting access to your information",
        acceptButton: "Accept",
        declineButton: "Decline"
      }
    },
    resetPasswordRequest: {
      title: "Reset Password",
      request: {
        title: "Reset Password",
        subtitle: "Enter your email address below and we will send instructions on how to reset your password.",
        emailLabel: "Email",
        continueButton: "Reset Password",
        cancelButton: "Cancel"
      },
      success: {
        title: "Check your email!",
        subtitle: "We sent an email with instructions on how to reset your password",
        resendEmailButton: "Resend email"
      },
      errors: {
        missingParameters: "",
        accountDoesNotExist: "Email not registered",
        unableToSendEmail: "The email could not be sent. Please try again later",
        invalidEmail: "Invalid email"
      }
    },
    resetPassword: {
      title: "Reset Password",
      errorTitle: "Reset Password Error",
      reset: {
        title: "Reset Password",
        subtitle: "Enter your new password below",
        passwordLabel: "New password",
        confirmPasswordLabel: "Confirm new password",
        continueButton: "Reset Password",
        cancelButton: "Cancel"
      },
      success: {
        title: "Your password has been changed",
        subtitle: "You can now log in with your new password"
      },
      errors: {
        missingParameters: "",
        passwordMismatch: "Password do not match",
        invalidPassword: "Invalid password",
        invalidCode: "The password reset link has expired or is invalid",
        unableToRevokeAccess: "",
        default: "It was not possible to reset your password"
      }
    },
    verifyEmail: {
      title: "Verify Email",
      errorTitle: "Email Verification Error",
      success: {
        title: "Email verification",
        subtitle: "Your email address has been verified successfully."
      },
      errors: {
        missingParameters: "",
        verificationCodeExpired: "The email verification link has expired or is invalid",
        default: "It was not possible to verify your email address."
      }
    },
    logout: {
      title: "Logout",
      confirm: {
        title: "Logout",
        subtitle: "Are you sure you want to logout?",
        yesButton: "Yes, log me out",
        noButton: "No, stay logged in"
      },
      success: {
        title: "Success!",
        subtitle: "You have been successfully logged out."
      }
    },
    socialLogin: {
      errorTitle: "${this.provider} Login Error",
      errors: {
        emailAlreadyTaken: {
          title: "Email already in use",
          message: "An account with the same email as your ${this.provider} account already exists."
        },
        accessDenied: {
          title: "Access Denied",
          message: "The user or administrator has denied consent for this application."
        },
        consentRequired: {
          title: "Consent Required",
          message: "The user has not consented to use the application."
        },
        invalidSession: {
          title: "Login Error",
          message: "It was not possible to login with ${this.provider}. Cause: Invalid session."
        },
        missingParameters: {
          title: "Login Error",
          message: "It was not possible to login with ${this.provider}. Cause: Missing parameters."
        },
        providerError: {
          title: "Provider Error",
          message: "${this.provider} returned an error: ${this.error}"
        },
        accountCreationError: {
          title: "Account Creation Error",
          message: "It was not possible to create an account"
        },
        missingEmailClaim: {
          title: "No Email Address",
          message: "${this.provider} did not return an email address. Please check your ${this.provider} account settings."
        },
        default: {
          title: "Login Error",
          message: "It was not possible to login with ${this.provider}."
        }
      },
      providers: {
        google: "Google",
        facebook: "Facebook",
        microsoft: "Microsoft",
        azureAD: "Entra ID"
      }
    },
    admin: {
      title: "User Administration",
      backWithLabel: "Back to ${this.returnLabel}",
      backWithoutLabel: "Back to app",
      home: {
        emailLabel: "Email",
        localizationLabel: "Localization",
        phoneLabel: "Phone",
        addressLabel: "Address",
        securityButton: "Security Settings"
      },
      email: {
        title: "Change Email",
        confirmEmail: "Confirm Email",
        save: "Save Changes",
        cancel: "Cancel"
      },
      localization: {
        title: "Localization",
        language: "Language",
        country: "Country",
        save: "Save Changes",
        cancel: "Cancel"
      },
      phone: {
        title: "Phone",
        save: "Save Changes",
        cancel: "Cancel"
      },
      address: {
        title: "Address",
        save: "Save Changes",
        cancel: "Cancel"
      },
      profile: {
        title: "Profile",
        save: "Save Changes",
        cancel: "Cancel"
      },
      security: {
        home: {
          title: "Security Settings",
          password: {
            label: "Password",
            description: "Change your password"
          },
          totp: {
            label: "Verification App (TOTP)",
            setupDescription: "Not Configured",
            updateDescription: "Change your verification app"
          },
          back: "Back",
          notAvailable: "There are no security settings available. The security of your account is managed by a third-party provider."
        },
        password: {
          title: "Change Your Password",
          currentPassword: "Current Password",
          newPassword: "New Password",
          confirmPassword: "Confirm New Password",
          continue: "Continue",
          cancel: "Cancel",
          success: {
            title: "Password Changed",
            message: "Your password has been changed successfully. You may have to log in again with your new password."
          }
        },
        totp: {
          setupTitle: "Set up Verification App",
          setupSubtitle: "Scan the QR Code below using your preferred authenticator app and then enter the provided one-time code below",
          updateTitle: "Update Verification App",
          updateSubtitle: "Scan the QR Code below using your new authenticator app and then enter the provided one-time code below. You won't be able to use the old authenticator app anymore.",
          code: "Enter code",
          continue: "Continue",
          cancel: "Cancel",
          success: {
            title: "Verification App Set Up",
            message: "Your verification app has been set up successfully."
          }
        }
      },
      status: {
        backButton: "Back to Profile"
      },
      claims: {
        profile: {
          name: "Full Name",
          family_name: "Last Name",
          given_name: "First Name",
          middle_name: "Middle Name",
          nickname: "Nickname",
          preferred_username: "Username",
          profile: "Profile",
          picture: "Profile Picture URL",
          website: "Website URL",
          gender: "Gender",
          birthdate: "Birthdate",
          zoneinfo: "Timezone",
          locale: "Locale",
          updated_at: "Last Updated At"
        },
        email: {
          email: "Email Address",
          email_verified: "Email Verified"
        },
        address: {
          address: "Address"
        },
        phone: {
          phone_number: "Phone Number",
          phone_number_verified: "Phone Number Verified"
        }
      },
      errors: {
        invalidIdentityProvider: "",
        emailNotAvailable: "Email already in use",
        emailConfirmationRequired: "Email confirmation is required",
        invalidEmail: "Invalid email",
        emailMismatch: "Confirmation email does not match",
        passwordMismatch: "Password do not match",
        currentPasswordRequired: "Current password is required",
        incorrectPassword: "Incorrect password",
        invalidNewPassword: "Invalid password",
        missingParameters: "",
        unableToRevokeAccess: "",
        mfaDisabled: "",
        invalidOtpCode: "Invalid code"
      }
    },
    errors: {
      serverError: {
        title: "Something went wrong",
        message: "An unexpected error occurred. Please contact the support team."
      },
      // OIDC provider
      invalidToken: {
        title: "Invalid Token",
        message: "The token provided is invalid."
      },
      invalidRedirectUri: {
        title: "Invalid Redirect URI",
        message: "The redirect URI provided did not match any of the client's registered redirect URIs."
      },
      invalidClientMetadata: {
        title: "Invalid Client Metadata",
        message: "The client metadata provided is invalid."
      },
      invalidScope: {
        title: "Invalid Scope",
        message: "The scope provided is invalid."
      },
      insufficientScope: {
        title: "Insufficient Scope",
        message: "The scope provided is insufficient."
      },
      invalidRequest: {
        title: "Invalid Request",
        message: "The request provided is invalid."
      },
      invalidClient: {
        title: "Invalid Application",
        message: "The application provided does not exist or could not be authenticated."
      },
      invalidGrant: {
        title: "Invalid Grant",
        message: "The grant request is invalid."
      },
      webMessageUriMismatch: {
        title: "Web Message URI Mismatch",
        message: "The web message URI provided did not match any client's registered web message URIs."
      },
      accessDenied: {
        title: "Access Denied",
        message: "Access to the requested resource is denied."
      },
      authorizationPending: {
        title: "Authorization Pending",
        message: "The authorization request is still pending as the end-user hasn't yet completed the user interaction steps."
      },
      consentRequired: {
        title: "Consent Required",
        message: "Consent is required to access the requested resource."
      },
      expiredLoginHintToken: {
        title: "Expired Login Hint Token",
        message: "The login hint token provided has expired."
      },
      expiredToken: {
        title: "Expired Token",
        message: "The token provided has expired."
      },
      interactionRequired: {
        title: "Interaction Required",
        message: "User interaction is required to access the requested resource."
      },
      invalidBindingMessage: {
        title: "Invalid Binding Message",
        message: "The binding message provided is invalid."
      },
      invalidDpopProof: {
        title: "Invalid DPoP Proof",
        message: "The DPoP proof provided is invalid."
      },
      invalidRequestObject: {
        title: "Invalid Request Object",
        message: "The request object provided is invalid."
      },
      invalidRequestUri: {
        title: "Invalid Request URI",
        message: "The request URI provided is invalid."
      },
      invalidSoftwareStatement: {
        title: "Invalid Software Statement",
        message: "The software statement provided is invalid."
      },
      invalidTarget: {
        title: "Invalid Target",
        message: "The resource indicator is missing or unknown."
      },
      invalidUserCode: {
        title: "Invalid User Code",
        message: "The user code provided is invalid."
      },
      loginRequired: {
        title: "Login Required",
        message: "Login is required to access the requested resource."
      },
      missingUserCode: {
        title: "Missing User Code",
        message: "The user code is missing."
      },
      registrationNotSupported: {
        title: "Registration Not Supported",
        message: "The registration parameter provided is not supported."
      },
      requestNotSupported: {
        title: "Request Not Supported",
        message: "The request parameter provided is not supported."
      },
      requestUriNotSupported: {
        title: "Request URI Not Supported",
        message: "The request URI parameter provided is not supported."
      },
      slowDown: {
        title: "Slow Down",
        message: "You are polling too quickly and should back off at a reasonable rate."
      },
      temporarilyUnavailable: {
        title: "Temporarily Unavailable",
        message: "The requested resource is temporarily unavailable."
      },
      transactionFailed: {
        title: "Transaction Failed",
        message: "The transaction failed."
      },
      unapprovedSoftwareStatement: {
        title: "Unapproved Software Statement",
        message: "The software statement is unapproved."
      },
      unauthorizedClient: {
        title: "Unauthorized Client",
        message: "The client is unauthorized."
      },
      unknownUserId: {
        title: "Unknown User ID",
        message: "The user ID is unknown."
      },
      unsupportedGrantType: {
        title: "Unsupported Grant Type",
        message: "The requested grant type is unsupported."
      },
      unsupportedResponseMode: {
        title: "Unsupported Response Mode",
        message: "The requested response mode is unsupported."
      },
      unsupportedResponseType: {
        title: "Unsupported Response Type",
        message: "The requested response type is unsupported."
      },
      // Server
      tenantNotReady: {
        title: "Tenant Not Ready",
        message: "The tenant you are trying to access is not currently available. This may be because it is still being set up or undergoing maintenance. Please try again later."
      },
      invalidResource: {
        title: "Invalid Resource",
        message: "The requested resource is invalid."
      },
      invalidTenant: {
        title: "Invalid Tenant",
        message: "The tenant you are trying to access does not exist. Please double-check the spelling of the tenant's name and ensure it has been properly registered."
      },
      invalidLocale: {
        title: "Invalid Language",
        message: "The requested language is not available. Please select a supported language."
      },
      invalidApplication: {
        title: "Invalid Application",
        message: "The requested application does not exist."
      },
      invalidConnector: {
        title: "Invalid Connector",
        message: "The requested connector does not exist."
      },
      invalidOperation: {
        title: "Invalid Operation",
        message: "The requested operation is invalid."
      },
      invalidInteractionSession: {
        title: "Invalid Interaction Session",
        message: "The session expired. Please try again."
      },
      // UI
      invalidView: {
        title: "Not Found",
        message: "The page you are trying to access does not exist."
      }
    }
  }
};

const deLanguage = {
  authFlows: {
    base: {
      passwordRequirements: {
        title: "Das Passwort muss Folgendes enthalten:",
        nonEmpty: "Mindestens ein Zeichen",
        minLength: "Mindestens ${this.connectors.database.passwordMinLength} Zeichen",
        lowercase: "Mindestens ein Kleinbuchstabe (a-z)",
        uppercase: "Mindestens ein Gro\xDFbuchstabe (A-Z)",
        number: "Mindestens eine Zahl (0-9)",
        specialChar: "Mindestens ein Sonderzeichen (z. B. !@#$%^&*)",
        noDuplication: "Nicht mehr als 2 identische Zeichen hintereinander"
      },
      emailVerificationRequired: {
        title: "E-Mailadresse best\xE4tigen",
        subtitle: "Um auf Ihr Konto zugreifen zu k\xF6nnen, m\xFCssen wir Ihre E-Mailadresse verifizieren. Eine E-Mail mit Anweisungen, wie Sie fortfahren k\xF6nnen, wurde an Sie gesendet",
        resendEmailButton: "E-Mail erneut senden",
        emailAlreadyVerified: "Ihre E-Mailadresse wurde bereits verifiziert",
        unableToSendEmail: "Die E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es sp\xE4ter erneut"
      },
      status: {
        backButton: "Zur\xFCck zu ${this.app.name}"
      },
      errors: {
        default: "Ein Fehler ist aufgetreten"
      }
    },
    login: {
      title: "Login",
      credentials: {
        title: "Willkommen bei ${this.app.name}!",
        subtitle: "Melden Sie sich mit Ihrer E-Mail-Adresse und Passwort an",
        emailLabel: "E-Mail-Adresse",
        passwordLabel: "Passwort",
        resetPasswordLink: "Passwort vergessen?",
        continueButton: "Weiter",
        alternateLoginOptions: "Oder anmelden mit",
        signupPreMessage: "Noch kein Account?",
        signupLink: "Jetzt registrieren"
      },
      mfa: {
        title: "Zwei-Faktor-Authentifizierung",
        subtitle: "Um die Sicherheit Ihres Kontos zu erh\xF6hen, haben Sie die Zwei-Faktor-Authentifizierung aktiviert. Bitte geben Sie den 6-stelligen Code aus der Authentifizierungs-App auf Ihrem Mobilger\xE4t ein. Dieser Code stellt sicher, dass nur Sie auf Ihr Konto zugreifen k\xF6nnen.",
        codeLabel: "Gebe den Code ein",
        continueButton: "Weiter"
      },
      activationPassword: {
        title: "Lege dein Passwort fest",
        subtitle: "Bitte lege ein neues Passwort fest, um dein Konto zu sichern",
        passwordLabel: "Passwort",
        confirmPasswordLabel: "Passwort best\xE4tigen",
        continueButton: "Weiter",
        cancelButton: "Abbrechen"
      },
      errors: {
        missingParameters: "",
        incorrectCredentials: "Die E-Mail oder das Passwort ist falsch",
        accountBlocked: "Ihr Account wurde gesperrt",
        missingInformation: "",
        invalidOtpCode: "Ung\xFCltiger Code",
        invalidEmail: "Ung\xFCltige E-Mail",
        invalidPassword: "Ung\xFCltiges Passwort"
      }
    },
    signup: {
      title: "Registirerung",
      credentials: {
        title: "Account anlegen",
        subtitle: "Legen Sie hier mit Ihrer E-Mail-Adresse und Ihrem Passwort einen Account an",
        emailLabel: "E-Mail-Adresse ",
        passwordLabel: "Passwort",
        confirmPasswordLabel: "Passwort best\xE4tigen",
        continueButton: "Weiter",
        loginPreMessage: "Sie haben bereits einen Account?",
        loginLink: "Einloggen"
      },
      mfa: {
        title: "Sch\xFCtzen Sie ihr Konto",
        subtitle: "W\xE4hlen Sie die Methode zur Zwei-Faktor-Authentifizierung aus, die Sie verwenden m\xF6chten, um Ihr Konto zu sichern",
        continueButton: "Weiter",
        totp: {
          buttonLabel: "Verifikations-App (TOTP)",
          buttonDescription: "Scannen Sie einen QR-Code mit einer Authentifizierung-App und geben Sie den Einmal-Code ein, um ihre Identit\xE4t zu best\xE4tigen",
          title: "Verifikations-App einrichten",
          subtitle: "Scannen Sie den untenstehenden QR-Code mit Ihrer bevorzugten Authentifizierungs-App und geben Sie den bereitgestellten Einmal-Code unten ein",
          codeLabel: "Geben Sie den Code ein",
          continueButton: "Weiter",
          cancelButton: "Abbrechen"
        }
      },
      errors: {
        invalidSession: "",
        unableToSendEmail: "",
        signupDenied: "Die Registrierung f\xFCr diese Anwendung ist deaktiviert",
        missingParameters: "",
        missingAgreements: "Sie m\xFCssen allen Vereinbarungen zustimmen",
        passwordMismatch: "Die Passw\xF6rter stimmen nicht \xFCberein",
        emailAlreadyTaken: "E-Mail wird bereits verwendet",
        invalidEmail: "Ung\xFCltige E-Mail",
        invalidPassword: "Ung\xFCltiges Passwort",
        invalidAction: "",
        invalidOtpCode: "Ung\xFCltiger Code",
        captchaFailed: "Wir konnten nicht \xFCberpr\xFCfen, ob Sie ein Mensch sind. Versuchen Sie es in wenigen Sekunden erneut"
      }
    },
    consent: {
      title: "Anwendung autorisieren",
      main: {
        title: "Anwendung autorisieren",
        subtitle: "${this.app.name} beantragt Zugriff auf ihre Informationen",
        acceptButton: "Akzeptieren",
        declineButton: "Ablehnen"
      }
    },
    resetPasswordRequest: {
      title: "Passwort zur\xFCcksetzen",
      request: {
        title: "Passwort zur\xFCcksetzen",
        subtitle: "Bitte geben Sie unten Ihre E-Mail-Adresse ein, wir senden Ihnen im Anschluss Anweisungen zum Zur\xFCcksetzen Ihres Passworts zu.",
        emailLabel: "E-Mail-Adresse",
        continueButton: "Passwort zur\xFCcksetzen",
        cancelButton: "Abbrechen"
      },
      success: {
        title: "\xDCberpr\xFCfen Sie Ihre E-Mails!",
        subtitle: "Wir haben Ihnen eine E-Mail mit Anweisungen zum Zur\xFCcksetzen Ihres Passworts gesendet",
        resendEmailButton: "E-Mail erneut senden"
      },
      errors: {
        missingParameters: "",
        accountDoesNotExist: "Die angegebene E-Mailadresse ist nicht registriert",
        unableToSendEmail: "Die E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es sp\xE4ter erneut",
        invalidEmail: "Ung\xFCltige E-Mail"
      }
    },
    resetPassword: {
      title: "Passwort zur\xFCcksetzen",
      errorTitle: "Fehler beim Zur\xFCcksetzen des Passworts",
      reset: {
        title: "Passwort zur\xFCcksetzen",
        subtitle: "Geben Sie unten Ihr neues Passwort ein",
        passwordLabel: "Neues Passwort",
        confirmPasswordLabel: "Neues Passwort best\xE4tigen",
        continueButton: "Passwort zur\xFCcksetzen",
        cancelButton: "Abbrechen"
      },
      success: {
        title: "Ihr Passwort wurde ge\xE4ndert",
        subtitle: "Sie k\xF6nnen sich nun mit Ihrem neuen Passwort anmelden"
      },
      errors: {
        missingParameters: "",
        passwordMismatch: "Die eingegebenen Passw\xF6rter stimmen nicht \xFCberein",
        invalidPassword: "Ung\xFCltiges Passwort",
        invalidCode: "Der Link zum Zur\xFCcksetzen des Passworts ist abgelaufen oder ung\xFCltig",
        unableToRevokeAccess: "",
        default: "Das Passwort konnte nicht zur\xFCckgesetzt werden"
      }
    },
    verifyEmail: {
      title: "E-Mail verifizieren",
      errorTitle: "Ein Fehler ist bei der E-Mail-Verifizierung aufgetreten",
      success: {
        title: "E-Mail-Verifizierung",
        subtitle: "Deine E-Mail-Adresse wurde erfolgreich verifiziert"
      },
      errors: {
        missingParameters: "",
        verificationCodeExpired: "Der Link zur E-Mail-Verifizierung ist abgelaufen oder ung\xFCltig",
        default: "Verifizierung deiner E-Mailadresse war nicht m\xF6glich"
      }
    },
    logout: {
      title: "Abmelden",
      confirm: {
        title: "Abmelden",
        subtitle: "Sind Sie sicher, dass Sie sich abmelden m\xF6chten?",
        yesButton: "Ja, abmelden",
        noButton: "Nein, eingeloggt bleiben"
      },
      success: {
        title: "Abgemeldet!",
        subtitle: "\xB4Sie wurden erfolgreich abgemeldet."
      }
    },
    socialLogin: {
      errorTitle: "Fehler beim Einloggen mit ${this.provider}",
      errors: {
        emailAlreadyTaken: {
          title: "E-Mail-Adresse wird bereits verwendet",
          message: "Ein Konto mit derselben E-Mail-Adresse wie dein ${this.provider}-Konto existiert bereits."
        },
        accessDenied: {
          title: "Zugriff verweigert",
          message: "Der Benutzer oder der Administrator hat die Zustimmung f\xFCr diese Anwendung verweigert"
        },
        consentRequired: {
          title: "Einwilligung erforderlich",
          message: "Der Nutzer hat der Nutzung der Anwendung nicht zugestimmt"
        },
        invalidSession: {
          title: "Anmeldefehler",
          message: "Die Anmeldung mit ${this.provider} war nicht m\xF6glich. Ursache: Ung\xFCltige Sitzung."
        },
        missingParameters: {
          title: "Anmeldefehler",
          message: "Die Anmeldung mit ${this.provider} war nicht m\xF6glich. Ursache: Fehlende Parameter."
        },
        providerError: {
          title: "Anbieterfehler",
          message: "${this.provider} hat einen Fehler zur\xFCckgegeben: ${this.error}"
        },
        accountCreationError: {
          title: "Fehler bei der Kontoerstellung",
          message: "Es war nicht m\xF6glich, ein Konto zu erstellen"
        },
        missingEmailClaim: {
          title: "Keine E-Mail-Adresse",
          message: "${this.provider} hat keine E-Mail-Adresse zur\xFCckgegeben. Bitte \xFCberpr\xFCfe die Einstellungen deines ${this.provider}-Kontos."
        },
        default: {
          title: "Anmeldefehler",
          message: "Die Anmeldung mit ${this.provider} war nicht m\xF6glich"
        }
      },
      providers: {
        google: "Google",
        facebook: "Facebook",
        microsoft: "Microsoft",
        azureAD: "Entra ID"
      }
    },
    admin: {
      title: "Benutzerverwaltung",
      backWithLabel: "Zur\xFCck zu ${this.returnLabel}",
      backWithoutLabel: "Zur\xFCck zur App",
      home: {
        emailLabel: "E-Mail",
        localizationLabel: "Standort",
        phoneLabel: "Telefon",
        addressLabel: "Adresse",
        securityButton: "Sicherheitseinstellungen"
      },
      email: {
        title: "E-Mail \xE4ndern",
        confirmEmail: "E-Mail best\xE4tigen",
        save: "\xC4nderungen speichern",
        cancel: "Abbrechen"
      },
      localization: {
        title: "Standort",
        language: "Sprache",
        country: "Land",
        save: "\xC4nderungen speichern",
        cancel: "Abbrechen"
      },
      phone: {
        title: "Telefon",
        save: "Save Changes",
        cancel: "Abbrechen"
      },
      address: {
        title: "Adresse",
        save: "\xC4nderungen speichern",
        cancel: "Abbrechen"
      },
      profile: {
        title: "Profil",
        save: "\xC4nderungen speichern",
        cancel: "Abbrechen"
      },
      security: {
        home: {
          title: "Sicherheitseinstellungen",
          password: {
            label: "Passwort",
            description: "Passwort \xE4ndern"
          },
          totp: {
            label: "Verifizierungs-App (TOTP)",
            setupDescription: "Nicht konfiguriert",
            updateDescription: "\xC4ndere deine Verifizierungs-App"
          },
          back: "Zur\xFCck",
          notAvailable: "Es sind keine Sicherheitseinstellungen verf\xFCgbar. Die Sicherheit deines Kontos wird von einem Drittanbieter verwaltet."
        },
        password: {
          title: "Passwort \xE4ndern",
          currentPassword: "Aktuelles Passwort",
          newPassword: "Neues Passwort",
          confirmPassword: "Neues Passwort best\xE4tigen",
          continue: "Weiter",
          cancel: "Abbrechen",
          success: {
            title: "Passwort ge\xE4ndert",
            message: "Dein Passwort wurde erfolgreich ge\xE4ndert. Du musst dich m\xF6glicherweise erneut mit deinem neuen Passwort anmelden."
          }
        },
        totp: {
          setupTitle: "Einrichtung der Verifizierungs-App",
          setupSubtitle: "Scanne den QR-Code unten mit deiner bevorzugten Authenticator-App und gib dann den bereitgestellten Einmalcode ein",
          updateTitle: "Aktualisierung der Verifizierungs-App",
          updateSubtitle: "Scanne den QR-Code unten mit deiner neuen Authenticator-App und gib dann den bereitgestellten Einmalcode ein. Du kannst die alte Authenticator-App nicht mehr verwenden.",
          code: "Code eingeben",
          continue: "Weiter",
          cancel: "Abbrechen",
          success: {
            title: "Verifizierungs-App eingerichtet",
            message: "Deine Verifizierungs-App wurde erfolgreich eingerichtet."
          }
        }
      },
      status: {
        backButton: "Zur\xFCck zum Profil"
      },
      claims: {
        profile: {
          name: "Vollst\xE4ndiger Name",
          family_name: "Nachname",
          given_name: "Vorname",
          middle_name: "Zweiter Vorname",
          nickname: "Spitzname",
          preferred_username: "Benutzername",
          profile: "Profil",
          picture: "Profilbild URL",
          website: "Website URL",
          gender: "Geschlecht",
          birthdate: "Geburtsdatum",
          zoneinfo: "Zeitzone",
          locale: "Standort",
          updated_at: "Zuletzt aktualisiert am"
        },
        email: {
          email: "E-Mail-Adresse",
          email_verified: "E-Mail verifiziert"
        },
        address: {
          address: "Adresse"
        },
        phone: {
          phone_number: "Telefonnummer",
          phone_number_verified: "Telefonnummer verifiziert"
        }
      },
      errors: {
        invalidIdentityProvider: "",
        emailNotAvailable: "E-Mail bereits in Verwendung",
        emailConfirmationRequired: "E-Mail-Best\xE4tigung erforderlich",
        invalidEmail: "Ung\xFCltige E-Mail",
        emailMismatch: "Die E-Mail-Best\xE4tigung stimmt nicht \xFCberein",
        passwordMismatch: "Passw\xF6rter stimmen nicht \xFCberein",
        currentPasswordRequired: "Aktuelles Passwort ist erforderlich",
        incorrectPassword: "Falsches Passwort",
        invalidNewPassword: "Ung\xFCltiges Passwort",
        missingParameters: "",
        unableToRevokeAccess: "",
        mfaDisabled: "",
        invalidOtpCode: "Ung\xFCltiger Code"
      }
    },
    errors: {
      serverError: {
        title: "Etwas ist schiefgelaufen",
        message: "Ein unerwarteter Fehler ist aufgetreten. Bitte kontaktieren Sie das Support-Team"
      },
      // OIDC provider
      invalidToken: {
        title: "Ung\xFCltiger Token",
        message: "Angegebener Token ist ung\xFCltig"
      },
      invalidRedirectUri: {
        title: "Ung\xFCltige Redirect URI",
        message: "Der angegebene Redirect-URI stimmte mit keinem der registrierten Redirect-URIs des Clients \xFCberein."
      },
      invalidClientMetadata: {
        title: "Ung\xFCltige Client-Metadaten",
        message: "Die bereitgestellten Client-Metadaten sind ung\xFCltig."
      },
      invalidScope: {
        title: "Ung\xFCltiger Scope",
        message: "Der bereitgestellte Scope ist ung\xFCltig."
      },
      insufficientScope: {
        title: "Unzureichender Scope",
        message: "Der angegebene Scope ist unzureichend."
      },
      invalidRequest: {
        title: "Ung\xFCltige Anfrage",
        message: "Die angegebene Anfrage ist ung\xFCltig."
      },
      invalidClient: {
        title: "Ung\xFCltige Anwendung",
        message: "Die angegebene Anwendung existiert nicht oder konnte nicht authentifiziert werden."
      },
      invalidGrant: {
        title: "Ung\xFCltige Berechtigung",
        message: "Die angegebene Berechtigung ist ung\xFCltig."
      },
      webMessageUriMismatch: {
        title: "Web Message URI stimmt nicht \xFCberein",
        message: "Die bereitgestellte Web Message URI stimmt mit keiner registrierten Web Message URI des Clients \xFCberein."
      },
      accessDenied: {
        title: "Zugriff verweigert",
        message: "Der Zugriff auf die angeforderte Ressource wurde verweigert."
      },
      authorizationPending: {
        title: "Autorisierung ausstehend",
        message: "Die Autorisierungsanfrage wird noch bearbeitet, da der Endbenutzer die Interaktionsschritte noch nicht abgeschlossen hat."
      },
      consentRequired: {
        title: "Zustimmung ben\xF6tigt",
        message: "Um auf die angeforderte Ressource zugreifen zu k\xF6nnen, ist eine Zustimmung erforderlich."
      },
      expiredLoginHintToken: {
        title: "Login Hint Token abgelaufen",
        message: "Bereitgestellter Login Hint Token abgelaufen."
      },
      expiredToken: {
        title: "Abgelaufener Token",
        message: "Bereitgestellter Token ist abgelaufen."
      },
      interactionRequired: {
        title: "Interaktion erforderlich",
        message: "Um auf die angeforderte Ressource zuzugreifen, ist eine Benutzerinteraktion erforderlich."
      },
      invalidBindingMessage: {
        title: "Ung\xFCltige Binding Message",
        message: "Bereitgestellte Binding Message ist ung\xFCltig."
      },
      invalidDpopProof: {
        title: "Ung\xFCltiger DPoP Proof",
        message: "Bereitgestellter DPoP proof ist ung\xFCltig."
      },
      invalidRequestObject: {
        title: "Ung\xFCltiges Request Object",
        message: "Bereitgestelltes Request Object ist ung\xFCltig."
      },
      invalidRequestUri: {
        title: "Ung\xFCltige Request URI",
        message: "Bereitgestellte Request URI ist ung\xFCltig."
      },
      invalidSoftwareStatement: {
        title: "Ung\xFCltiges Software Statement",
        message: "Bereitgestelltes Software Statement ist ung\xFCltig."
      },
      invalidTarget: {
        title: "Ung\xFCltiges Ziel",
        message: "Der Indikator f\xFCr die Ressource fehlt oder ist nicht bekannt."
      },
      invalidUserCode: {
        title: "Ung\xFCltiger User Code",
        message: "Bereitgestellter User Code ist ung\xFCltig."
      },
      loginRequired: {
        title: "Anmeldung erforderlich",
        message: "Um auf die angeforderte Ressource zuzugreifen, ist eine Anmeldung erforderlich."
      },
      missingUserCode: {
        title: "Fehlender User Code",
        message: "Der User Code fehlt."
      },
      registrationNotSupported: {
        title: "Registrierung wird nicht unterst\xFCtzt",
        message: "Der angegebene Registration Parameter wird nicht unterst\xFCtzt."
      },
      requestNotSupported: {
        title: "Anfrage wird nicht unterst\xFCtzt",
        message: "Die angegebene Anfrage wird nicht unterst\xFCtzt."
      },
      requestUriNotSupported: {
        title: "Angegebene Request URI wird nicht unterst\xFCtzt",
        message: "Der bereitgestellte Anforderungs-URI-Parameter wird nicht unterst\xFCtzt."
      },
      slowDown: {
        title: "Mach Langsam",
        message: "Sie stellen die Anfragen zu schnell. Reduzieren Sie bitte ihre Geschwindigkeit."
      },
      temporarilyUnavailable: {
        title: "Vor\xFCbergehend nicht erreichbar",
        message: "Die angeforderte Ressource ist vor\xFCbergehend nicht erreichbar."
      },
      transactionFailed: {
        title: "Transaction fehlgeschlagen",
        message: "Der Vorgang ist fehlgeschlagen."
      },
      unapprovedSoftwareStatement: {
        title: "Ungenehmigtes Software-Statement",
        message: "Software-Statement wurde nicht genehmigt."
      },
      unauthorizedClient: {
        title: "Unautorisierter Client",
        message: "Der Client ist nicht autorisiert."
      },
      unknownUserId: {
        title: "Unbekannte User ID",
        message: "Die User ID ist nicht bekannt."
      },
      unsupportedGrantType: {
        title: "Nicht unterst\xFCtzter Grant Type",
        message: "Der angeforderte Grant-Typ wird nicht unterst\xFCtzt."
      },
      unsupportedResponseMode: {
        title: "Nicht unterst\xFCtzter Response Mode",
        message: "Der angeforderte Response Mode wird nicht unterst\xFCtzt."
      },
      unsupportedResponseType: {
        title: "Nicht unterst\xFCtzter Response Type",
        message: "Der angeforderte Response Type wird nicht unterst\xFCtzt."
      },
      // Server
      tenantNotReady: {
        title: "Der Tenant ist nicht bereit",
        message: "Der Tenant, auf den Sie zugreifen m\xF6chten, ist derzeit nicht verf\xFCgbar. Dies kann daran liegen, dass er noch eingerichtet wird oder Wartungsarbeiten durchgef\xFChrt werden. Bitte versuchen Sie es sp\xE4ter erneut."
      },
      invalidResource: {
        title: "Ung\xFCltige Resource",
        message: "Die angeforderte Quelle ist ung\xFCltig."
      },
      invalidTenant: {
        title: "Ung\xFCltiger Tenant",
        message: "Der Tenant, auf den Sie zugreifen m\xF6chten, existiert nicht. Bitte \xFCberpr\xFCfen Sie die Schreibweise des Tenant-Namens und stellen Sie sicher, dass er ordnungsgem\xE4\xDF registriert wurde."
      },
      invalidLocale: {
        title: "Ung\xFCltige Sprache",
        message: "Die angeforderte Sprache ist nicht verf\xFCgbar. Bitte w\xE4hlen Sie eine unterst\xFCtzte Sprache aus."
      },
      invalidApplication: {
        title: "Ung\xFCltige Anwendung",
        message: "Die angegebene Anwendung existiert nicht."
      },
      invalidConnector: {
        title: "Ung\xFCltiger Connector",
        message: "Der angegebene Connector existiert nicht."
      },
      invalidOperation: {
        title: "Ung\xFCltige Operation",
        message: "Die angegebene Operation existiert nicht."
      },
      invalidInteractionSession: {
        title: "Interaction session ung\xFCltig",
        message: "Die Sitzung ist abgelaufen. Bitte versuche es erneut."
      },
      // UI
      invalidView: {
        title: "Nicht gefunden",
        message: "Die Seite, auf die Sie zugreifen m\xF6chten, existiert nicht."
      }
    }
  }
};

const itLanguage = {
  authFlows: {
    base: {
      passwordRequirements: {
        title: "La password deve contenere:",
        nonEmpty: "Almeno un carattere",
        minLength: "Almeno ${this.connectors.database.passwordMinLength} caratteri",
        lowercase: "Almeno un carattere minuscolo (a-z)",
        uppercase: "Almeno un carattere maiuscolo (A-Z)",
        number: "Almeno un numero (0-9)",
        specialChar: "Almeno un carattere speciale (ad esempio, @#$%^&*)",
        noDuplication: "Non pi\xF9 di 2 caratteri identici in fila"
      },
      emailVerificationRequired: {
        title: "Confermare l'indirizzo e-mail",
        subtitle: "Per accedere al suo account dobbiamo verificare il suo indirizzo e-mail. Le \xE8 stata inviata un'e-mail con le istruzioni su come procedere.",
        resendEmailButton: "Reinvio dell'e-mail",
        emailAlreadyVerified: "Il tuo indirizzo e-mail \xE8 gi\xE0 stato verificato",
        unableToSendEmail: "Non \xE8 stato possibile inviare l'e-mail. Riprovare pi\xF9 tardi"
      },
      status: {
        backButton: "Torna a ${this.app.name}"
      },
      errors: {
        default: "Qualcosa \xE8 andato storto"
      }
    },
    login: {
      title: "Accesso",
      credentials: {
        title: "Benvenuto su ${this.app.name}!",
        subtitle: "Accedere con l'e-mail e la password",
        emailLabel: "E-Mail",
        passwordLabel: "Password",
        resetPasswordLink: "Dimenticato la password?",
        continueButton: "Continua",
        alternateLoginOptions: "O accedere con",
        signupPreMessage: "Non sei un membro?",
        signupLink: "Iscriviti adesso"
      },
      mfa: {
        title: "Verifica in 2 fasi",
        subtitle: "Per migliorare la sicurezza del vostro account, avete attivato l'autenticazione a due fattori. Inserite il codice a 6 cifre dall'app di autenticazione del vostro dispositivo mobile. Questo codice garantisce che solo voi possiate accedere al vostro account.",
        codeLabel: "Inserisci il codice",
        continueButton: "continuare"
      },
      activationPassword: {
        title: "Imposta la tua password",
        subtitle: "Imposta una nuova password per proteggere il tuo account",
        passwordLabel: "Password",
        confirmPasswordLabel: "Confermare la password",
        continueButton: "Continua",
        cancelButton: "Annullamento"
      },
      errors: {
        incorrectCredentials: "L'e-mail o la password non sono corrette",
        accountBlocked: "Il tuo account \xE8 stato bloccato",
        invalidOtpCode: "Codice non valido",
        invalidEmail: "Email non valida",
        invalidPassword: "Password non valida"
      }
    },
    signup: {
      title: "registrare",
      credentials: {
        title: "registrare",
        subtitle: "Creare un account con la propria e-mail e password",
        emailLabel: "E-Mail",
        passwordLabel: "Password",
        confirmPasswordLabel: "Confermare la password",
        continueButton: "Continua",
        loginPreMessage: "Avete gi\xE0 un account?",
        loginLink: "Accedi"
      },
      mfa: {
        title: "Proteggere il proprio account",
        subtitle: "Seleziona il metodo di autenticazione a 2 fattori che desideri utilizzare per proteggere il tuo account",
        continueButton: "Continua",
        totp: {
          buttonLabel: "App di verifica (TOTP)",
          buttonDescription: "Scansiona un codice QR con un'app di verifica e inserisci il codice monouso per verificare la tua identit\xE0",
          title: "Configura l'app di verifica",
          subtitle: "Scansionare il codice QR qui sotto utilizzando l'applicazione di autenticazione preferita e quindi immettere il codice una tantum fornito qui sotto",
          codeLabel: "Inserire il codice",
          continueButton: "Continua",
          cancelButton: "Annullamento"
        }
      },
      errors: {
        signupDenied: "L'iscrizione \xE8 disabilitata per questa applicazione",
        missingAgreements: "\xC8 necessario accettare tutti gli accordi",
        passwordMismatch: "La password non corrisponde",
        emailAlreadyTaken: "Email gi\xE0 in uso",
        invalidEmail: "Email non valida",
        invalidPassword: "Password non valida",
        invalidOtpCode: "Codice non valido",
        captchaFailed: "Non siamo riusciti a verificare che tu sia un essere umano. Riprovare tra qualche secondo"
      }
    },
    consent: {
      title: "Autorizzare l'applicazione",
      main: {
        title: "Autorizzare l'applicazione",
        subtitle: "${this.app.name} chiede l'accesso alle sue informazioni",
        acceptButton: "Accettare",
        declineButton: "Declino"
      }
    },
    resetPasswordRequest: {
      title: "Reimpostare la password",
      request: {
        title: "Reimpostare la password",
        subtitle: "Inserite il vostro indirizzo e-mail e vi invieremo le istruzioni per reimpostare la password.",
        emailLabel: "E-Mail",
        continueButton: "Reimpostare la password",
        cancelButton: "Annullamento"
      },
      success: {
        title: "Controllate la vostra e-mail",
        subtitle: "Abbiamo inviato un'e-mail con le istruzioni per reimpostare la password.",
        resendEmailButton: "Reinvio dell'e-mail"
      },
      errors: {
        accountDoesNotExist: "Email non registrata",
        unableToSendEmail: "Non \xE8 stato possibile inviare l'e-mail. Riprovare pi\xF9 tardi",
        invalidEmail: "Email non valida"
      }
    },
    resetPassword: {
      title: "Reimpostare la password",
      errorTitle: "Errore di reimpostazione della password",
      reset: {
        title: "Reimpostare la password",
        subtitle: "Inserire la nuova password qui sotto",
        passwordLabel: "Nuova password",
        confirmPasswordLabel: "Confermare la nuova password",
        continueButton: "Reimpostare la password",
        cancelButton: "Annullamento"
      },
      success: {
        title: "La password \xE8 stata modificata",
        subtitle: "Ora \xE8 possibile accedere con la nuova passwor"
      },
      errors: {
        passwordMismatch: "La password non corrisponde",
        invalidPassword: "Password non valida",
        invalidCode: "Il link per la reimpostazione della password \xE8 scaduto o non \xE8 valido.",
        default: "Non \xE8 stato possibile reimpostare la password"
      }
    },
    verifyEmail: {
      title: "Verifica dell'e-mail",
      errorTitle: "Errore di verifica dell'e-mail",
      success: {
        title: "Verifica dell'e-mail",
        subtitle: "Il vostro indirizzo e-mail \xE8 stato verificato con successo."
      },
      errors: {
        verificationCodeExpired: "Il link di verifica dell'e-mail \xE8 scaduto o non \xE8 valido",
        default: "Non \xE8 stato possibile verificare il vostro indirizzo e-mail."
      }
    },
    logout: {
      title: "Logout",
      confirm: {
        title: "Logout",
        subtitle: "\xC8 sicuro di voler effettuare il logout?",
        yesButton: "S\xEC, disconnettetemi",
        noButton: "No, rimani connesso"
      },
      success: {
        title: "Il successo!",
        subtitle: "Il logout \xE8 stato effettuato con successo."
      }
    },
    socialLogin: {
      errorTitle: "${this.provider} Errore di accesso",
      errors: {
        emailAlreadyTaken: {
          title: "Email gi\xE0 in uso",
          message: "Un account con lo stesso indirizzo email del tuo account ${this.provider} esiste gi\xE0."
        },
        accessDenied: {
          title: "Accesso negato",
          message: "L'utente o l'amministratore ha rifiutato il consenso per questa applicazione"
        },
        consentRequired: {
          title: "Consentimento richiesto",
          message: "L'utente non ha acconsentito all'uso dell'applicazione"
        },
        default: {
          title: "Qualcosa \xE8 andato storto",
          message: "Non \xE8 stato possibile effettuare il login con ${this.provider}."
        }
      },
      providers: {
        google: "Google",
        facebook: "Facebook",
        microsoft: "Microsoft",
        azureAD: "Entra ID"
      }
    },
    admin: {
      title: "Gestione Utenti",
      backWithLabel: "Torna a ${this.returnLabel}",
      backWithoutLabel: "Torna all'app",
      home: {
        emailLabel: "Email",
        localizationLabel: "Localizzazione",
        phoneLabel: "Telefono",
        addressLabel: "Indirizzo",
        securityButton: "Impostazioni di Sicurezza"
      },
      email: {
        title: "Modifica Email",
        confirmEmail: "Conferma Email",
        save: "Salva Modifiche",
        cancel: "Annullamento"
      },
      localization: {
        title: "Localizzazione",
        language: "Lingua",
        country: "Paese",
        save: "Salva Modifiche",
        cancel: "Annullamento"
      },
      phone: {
        title: "Telefono",
        save: "Salva Modifiche",
        cancel: "Annullamento"
      },
      address: {
        title: "Indirizzo",
        save: "Salva Modifiche",
        cancel: "Annullamento"
      },
      profile: {
        title: "Profilo",
        save: "Salva Modifiche",
        cancel: "Annullamento"
      },
      security: {
        home: {
          title: "Impostazioni di Sicurezza",
          password: {
            label: "Password",
            description: "Modifica la tua password"
          },
          totp: {
            label: "App di Verifica (TOTP)",
            setupDescription: "Non Configurato",
            updateDescription: "Modifica la tua app di verifica"
          },
          back: "Indietro",
          notAvailable: "Non ci sono impostazioni di sicurezza disponibili. La sicurezza del tuo account \xE8 gestita da un provider terzo."
        },
        password: {
          title: "Cambia la Tua Password",
          currentPassword: "Password Attuale",
          newPassword: "Nuova Password",
          confirmPassword: "Conferma Nuova Password",
          continue: "Continua",
          cancel: "Annullamento",
          success: {
            title: "Password Cambiata",
            message: "La tua password \xE8 stata cambiata con successo. Potresti dover effettuare nuovamente il login con la tua nuova password."
          }
        },
        totp: {
          setupTitle: "Configura App di Verifica",
          setupSubtitle: "Scansiona il codice QR qui sotto utilizzando la tua app di autenticazione preferita e poi inserisci il codice monouso fornito di seguito",
          updateTitle: "Aggiorna App di Verifica",
          updateSubtitle: "Scansiona il codice QR qui sotto utilizzando la tua nuova app di autenticazione e poi inserisci il codice monouso fornito di seguito. Non sarai pi\xF9 in grado di utilizzare la vecchia app di autenticazione.",
          code: "Inserisci codice",
          continue: "Continua",
          cancel: "Annullamento",
          success: {
            title: "App di Verifica Configurata",
            message: "La tua app di verifica \xE8 stata configurata con successo."
          }
        }
      },
      status: {
        backButton: "Torna al Profilo"
      },
      claims: {
        profile: {
          name: "Nome Completo",
          family_name: "Cognome",
          given_name: "Nome",
          middle_name: "Secondo Nome",
          nickname: "Soprannome",
          preferred_username: "Nome Utente Preferito",
          profile: "Profilo",
          picture: "URL Immagine Profilo",
          website: "URL Sito Web",
          gender: "Sesso",
          birthdate: "Data di Nascita",
          zoneinfo: "Fuso Orario",
          locale: "Locale",
          updated_at: "Ultimo Aggiornamento il"
        },
        email: {
          email: "Indirizzo Email",
          email_verified: "Email Verificata"
        },
        address: {
          address: "Indirizzo"
        },
        phone: {
          phone_number: "Numero di Telefono",
          phone_number_verified: "Numero di Telefono Verificato"
        }
      },
      errors: {
        invalidIdentityProvider: "",
        emailNotAvailable: "Email gi\xE0 in uso",
        emailConfirmationRequired: "Conferma dell'email richiesta",
        invalidEmail: "Email non valida",
        emailMismatch: "L'email di conferma non corrisponde",
        passwordMismatch: "Le password non corrispondono",
        currentPasswordRequired: "La password attuale \xE8 richiesta",
        incorrectPassword: "Password errata",
        invalidNewPassword: "Password non valida",
        missingParameters: "",
        unableToRevokeAccess: "",
        mfaDisabled: "",
        invalidOtpCode: "Codice non valido"
      }
    },
    errors: {
      serverError: {
        title: "Qualcosa \xE8 andato storto",
        message: "Si \xE8 verificato un errore imprevisto. Contattare il team di assistenza."
      },
      // OIDC provider
      invalidToken: {
        title: "Invalid Token",
        message: "The token provided is invalid."
      },
      invalidRedirectUri: {
        title: "Invalid Redirect URI",
        message: "The redirect URI provided did not match any of the client's registered redirect URIs."
      },
      invalidClientMetadata: {
        title: "Invalid Client Metadata",
        message: "The client metadata provided is invalid."
      },
      invalidScope: {
        title: "Invalid Scope",
        message: "The scope provided is invalid."
      },
      insufficientScope: {
        title: "Insufficient Scope",
        message: "The scope provided is insufficient."
      },
      invalidRequest: {
        title: "Invalid Request",
        message: "The request provided is invalid."
      },
      invalidClient: {
        title: "Invalid Application",
        message: "The application provided does not exist or could not be authenticated."
      },
      invalidGrant: {
        title: "Invalid Grant",
        message: "The grant request is invalid."
      },
      webMessageUriMismatch: {
        title: "Web Message URI Mismatch",
        message: "The web message URI provided did not match any client's registered web message URIs."
      },
      accessDenied: {
        title: "Access Denied",
        message: "Access to the requested resource is denied."
      },
      authorizationPending: {
        title: "Authorization Pending",
        message: "The authorization request is still pending as the end-user hasn't yet completed the user interaction steps."
      },
      consentRequired: {
        title: "Consent Required",
        message: "Consent is required to access the requested resource."
      },
      expiredLoginHintToken: {
        title: "Expired Login Hint Token",
        message: "The login hint token provided has expired."
      },
      expiredToken: {
        title: "Expired Token",
        message: "The token provided has expired."
      },
      interactionRequired: {
        title: "Interaction Required",
        message: "User interaction is required to access the requested resource."
      },
      invalidBindingMessage: {
        title: "Invalid Binding Message",
        message: "The binding message provided is invalid."
      },
      invalidDpopProof: {
        title: "Invalid DPoP Proof",
        message: "The DPoP proof provided is invalid."
      },
      invalidRequestObject: {
        title: "Invalid Request Object",
        message: "The request object provided is invalid."
      },
      invalidRequestUri: {
        title: "Invalid Request URI",
        message: "The request URI provided is invalid."
      },
      invalidSoftwareStatement: {
        title: "Invalid Software Statement",
        message: "The software statement provided is invalid."
      },
      invalidTarget: {
        title: "Invalid Target",
        message: "The resource indicator is missing or unknown."
      },
      invalidUserCode: {
        title: "Invalid User Code",
        message: "The user code provided is invalid."
      },
      loginRequired: {
        title: "Login Required",
        message: "Login is required to access the requested resource."
      },
      missingUserCode: {
        title: "Missing User Code",
        message: "The user code is missing."
      },
      registrationNotSupported: {
        title: "Registration Not Supported",
        message: "The registration parameter provided is not supported."
      },
      requestNotSupported: {
        title: "Request Not Supported",
        message: "The request parameter provided is not supported."
      },
      requestUriNotSupported: {
        title: "Request URI Not Supported",
        message: "The request URI parameter provided is not supported."
      },
      slowDown: {
        title: "Slow Down",
        message: "You are polling too quickly and should back off at a reasonable rate."
      },
      temporarilyUnavailable: {
        title: "Temporarily Unavailable",
        message: "The requested resource is temporarily unavailable."
      },
      transactionFailed: {
        title: "Transaction Failed",
        message: "The transaction failed."
      },
      unapprovedSoftwareStatement: {
        title: "Unapproved Software Statement",
        message: "The software statement is unapproved."
      },
      unauthorizedClient: {
        title: "Unauthorized Client",
        message: "The client is unauthorized."
      },
      unknownUserId: {
        title: "Unknown User ID",
        message: "The user ID is unknown."
      },
      unsupportedGrantType: {
        title: "Unsupported Grant Type",
        message: "The requested grant type is unsupported."
      },
      unsupportedResponseMode: {
        title: "Unsupported Response Mode",
        message: "The requested response mode is unsupported."
      },
      unsupportedResponseType: {
        title: "Unsupported Response Type",
        message: "The requested response type is unsupported."
      },
      // Server
      tenantNotReady: {
        title: "Tenant Not Ready",
        message: "The tenant you are trying to access is not currently available. This may be because it is still being set up or undergoing maintenance. Please try again later."
      },
      invalidResource: {
        title: "Invalid Resource",
        message: "The requested resource is invalid."
      },
      invalidTenant: {
        title: "Invalid Tenant",
        message: "The tenant you are trying to access does not exist. Please double-check the spelling of the tenant's name and ensure it has been properly registered."
      },
      invalidLocale: {
        title: "Invalid Language",
        message: "The requested language is not available. Please select a supported language."
      },
      invalidApplication: {
        title: "Invalid Application",
        message: "The requested application does not exist."
      },
      invalidConnector: {
        title: "Invalid Connector",
        message: "The requested connector does not exist."
      },
      invalidOperation: {
        title: "Invalid Operation",
        message: "The requested operation is invalid."
      },
      invalidInteractionSession: {
        title: "Invalid Interaction Session",
        message: "The session expired. Please try again."
      },
      // UI
      invalidView: {
        title: "Not Found",
        message: "The page you are trying to access does not exist."
      }
    }
  }
};

const frLanguage = {
  authFlows: {
    base: {
      passwordRequirements: {
        title: "Votre mot de passe doit contenir:",
        nonEmpty: "Au moins un caract\xE8re",
        minLength: "Au moins ${this.connectors.database.passwordMinLength} caract\xE8res",
        lowercase: "Au moins un caract\xE8re minuscule (a-z)",
        uppercase: "Au moins un caract\xE8re majuscule (A-Z)",
        number: "Au moins un chiffre (0-9)",
        specialChar: "Au moins un caract\xE8re sp\xE9cial (par exemple !@#$%^&*)",
        noDuplication: "Pas plus de 2 caract\xE8res identiques \xE0 la suite"
      },
      emailVerificationRequired: {
        title: "Confirmez votre adresse \xE9lectronique",
        subtitle: "Pour acc\xE9der \xE0 votre compte, nous devons v\xE9rifier votre adresse \xE9lectronique. Un courriel contenant des instructions sur la mani\xE8re de proc\xE9der vous a \xE9t\xE9 envoy\xE9.",
        resendEmailButton: "Renvoyer le courriel",
        emailAlreadyVerified: "Votre adresse e-mail a d\xE9j\xE0 \xE9t\xE9 v\xE9rifi\xE9e",
        unableToSendEmail: "L'email n'a pas pu \xEAtre envoy\xE9. Veuillez r\xE9essayer plus tard"
      },
      status: {
        backButton: "Retour \xE0 ${this.app.name}"
      },
      errors: {
        default: "Quelque chose n'a pas fonctionn\xE9"
      }
    },
    login: {
      title: "Login",
      credentials: {
        title: "Bienvenue sur ${this.app.name}!",
        subtitle: "Connectez-vous \xE0 l'aide de votre adresse \xE9lectronique et de votre mot de passe",
        emailLabel: "E-Mail",
        passwordLabel: "Mot de passe",
        resetPasswordLink: "Mot de passe oubli\xE9?",
        continueButton: "Continuer",
        alternateLoginOptions: "Ou se connecter avec",
        signupPreMessage: "Vous n'\xEAtes pas membre?",
        signupLink: "S'inscrire maintenant"
      },
      mfa: {
        title: "V\xE9rification en 2 \xE9tapes",
        subtitle: "Pour renforcer la s\xE9curit\xE9 de votre compte, vous avez activ\xE9 l'authentification \xE0 deux facteurs. Veuillez saisir le code \xE0 6 chiffres de l'application d'authentification de votre appareil mobile. Ce code garantit que vous seul pouvez acc\xE9der \xE0 votre compte.",
        codeLabel: "Saisir le code",
        continueButton: "Continuer"
      },
      activationPassword: {
        title: "Configurez votre mot de passe",
        subtitle: "Veuillez configurer un nouveau mot de passe pour s\xE9curiser votre compte",
        passwordLabel: "Mot de passe",
        confirmPasswordLabel: "Confirmer le mot de passe",
        continueButton: "Continuer",
        cancelButton: "Annuler"
      },
      errors: {
        incorrectCredentials: "L'adresse \xE9lectronique ou le mot de passe est incorrect",
        accountBlocked: "Votre compte a \xE9t\xE9 bloqu\xE9",
        invalidOtpCode: "Code invalide",
        invalidEmail: "E-Mail non valide",
        invalidPassword: "Mot de passe invalide"
      }
    },
    signup: {
      title: "S'inscrire",
      credentials: {
        title: "S'inscrire",
        subtitle: "Cr\xE9ez un compte avec votre adresse \xE9lectronique et votre mot de passe",
        emailLabel: "E-Mail",
        passwordLabel: "Mot de passe",
        confirmPasswordLabel: "Confirmer le mot de passe",
        continueButton: "Continuer",
        loginPreMessage: "Vous avez d\xE9j\xE0 un compte?",
        loginLink: "Se connecter"
      },
      mfa: {
        title: "S\xE9curisez votre compte",
        subtitle: "S\xE9lectionnez la m\xE9thode d'authentification \xE0 2 facteurs que vous souhaitez utiliser pour s\xE9curiser votre compte",
        continueButton: "Continuer",
        totp: {
          buttonLabel: "Application de v\xE9rification (TOTP)",
          buttonDescription: "Num\xE9risez un QR-code avec une application de v\xE9rification et entrez le code \xE0 usage unique pour v\xE9rifier votre identit\xE9",
          title: "Configurer l'application de v\xE9rification",
          subtitle: "Scannez le code QR ci-dessous \xE0 l'aide de votre application d'authentification pr\xE9f\xE9r\xE9e, puis saisissez le code \xE0 usage unique fourni ci-dessous",
          codeLabel: "Saisir le code",
          continueButton: "Continuer",
          cancelButton: "Annuler"
        }
      },
      errors: {
        signupDenied: "L'inscription est d\xE9sactiv\xE9e pour cette application",
        missingAgreements: "Vous devez accepter tous les accords",
        passwordMismatch: "Le mot de passe ne correspond pas",
        emailAlreadyTaken: "Email d\xE9j\xE0 utilis\xE9",
        invalidEmail: "E-Mail non valide",
        invalidPassword: "Mot de passe invalide",
        invalidOtpCode: "Code invalide",
        captchaFailed: "Nous n'avons pas pu v\xE9rifier que vous \xEAtes un \xEAtre humain. R\xE9essayez dans quelques secondes"
      }
    },
    consent: {
      title: "Autoriser l'application",
      main: {
        title: "Autoriser l'application",
        subtitle: "${this.app.name} demande l'acc\xE8s \xE0 vos informations",
        acceptButton: "Accepter",
        declineButton: "D\xE9clin"
      }
    },
    resetPasswordRequest: {
      title: "R\xE9initialiser le mot de passe",
      request: {
        title: "R\xE9initialiser le mot de passe",
        subtitle: "Saisissez votre adresse \xE9lectronique ci-dessous et nous vous enverrons des instructions sur la mani\xE8re de r\xE9initialiser votre mot de passe.",
        emailLabel: "E-Mail",
        continueButton: "R\xE9initialiser le mot de passe",
        cancelButton: "Annuler"
      },
      success: {
        title: "V\xE9rifiez votre courrier \xE9lectronique!",
        subtitle: "Nous avons envoy\xE9 un courrier \xE9lectronique contenant des instructions sur la mani\xE8re de r\xE9initialiser votre mot de passe",
        resendEmailButton: "Renvoyer le courriel"
      },
      errors: {
        accountDoesNotExist: "Email non enregistr\xE9",
        unableToSendEmail: "L'email n'a pas pu \xEAtre envoy\xE9. Veuillez r\xE9essayer plus tard",
        invalidEmail: "E-Mail non valide"
      }
    },
    resetPassword: {
      title: "R\xE9initialiser le mot de passe",
      errorTitle: "Erreur de r\xE9initialisation du mot de passe",
      reset: {
        title: "R\xE9initialiser le mot de passe",
        subtitle: "Entrez votre nouveau mot de passe ci-dessous",
        passwordLabel: "Nouveau mot de passe",
        confirmPasswordLabel: "Confirmer le nouveau mot de passe",
        continueButton: "R\xE9initialiser le mot de passe",
        cancelButton: "Annuler"
      },
      success: {
        title: "Votre mot de passe a \xE9t\xE9 modifi\xE9",
        subtitle: "Vous pouvez maintenant vous connecter avec votre nouveau mot de passe"
      },
      errors: {
        passwordMismatch: "Le mot de passe ne correspond pas",
        invalidPassword: "Mot de passe invalide",
        invalidCode: "Le lien de r\xE9initialisation du mot de passe a expir\xE9 ou n'est pas valide",
        default: "Il n'a pas \xE9t\xE9 possible de r\xE9initialiser votre mot de passe"
      }
    },
    verifyEmail: {
      title: "V\xE9rifier l'email",
      errorTitle: "Erreur de v\xE9rification de l'email",
      success: {
        title: "V\xE9rification de l'e-mail",
        subtitle: "Votre adresse \xE9lectronique a \xE9t\xE9 v\xE9rifi\xE9e avec succ\xE8s."
      },
      errors: {
        verificationCodeExpired: "Le lien de v\xE9rification de l'email a expir\xE9 ou n'est pas valide",
        default: "Il n'a pas \xE9t\xE9 possible de v\xE9rifier votre adresse \xE9lectronique."
      }
    },
    logout: {
      title: "D\xE9connexionut",
      confirm: {
        title: "D\xE9connexion",
        subtitle: "\xCAtes-vous s\xFBr de vouloir vous d\xE9connecter ?",
        yesButton: "Oui, d\xE9connectez-moi",
        noButton: "Non, rester connect\xE9"
      },
      success: {
        title: "Succ\xE8s!",
        subtitle: "Vous avez \xE9t\xE9 d\xE9connect\xE9 avec succ\xE8s."
      }
    },
    socialLogin: {
      errorTitle: "${this.provider} Erreur de connexion",
      errors: {
        emailAlreadyTaken: {
          title: "Email d\xE9j\xE0 utilis\xE9",
          message: "Un compte avec la m\xEAme adresse e-mail que votre compte ${this.provider} existe d\xE9j\xE0."
        },
        accessDenied: {
          title: "Acc\xE8s refus\xE9",
          message: "L'utilisateur ou l'administrateur a refus\xE9 de donner son accord pour cette application"
        },
        consentRequired: {
          title: "Consentement Requis",
          message: "L'utilisateur n'a pas consenti \xE0 l'utilisation de l'application"
        },
        default: {
          title: "Erreur de connexion",
          message: "Il n'a pas \xE9t\xE9 possible de se connecter avec ${this.provider}."
        }
      },
      providers: {
        google: "Google",
        facebook: "Facebook",
        microsoft: "Microsoft",
        azureAD: "Entra ID"
      }
    },
    admin: {
      title: "Administration Utilisateur",
      backWithLabel: "Retour \xE0 ${this.returnLabel}",
      backWithoutLabel: "Retour \xE0 l'application",
      home: {
        emailLabel: "Email",
        localizationLabel: "Localisation",
        phoneLabel: "T\xE9l\xE9phone",
        addressLabel: "Adresse",
        securityButton: "Param\xE8tres de S\xE9curit\xE9"
      },
      email: {
        title: "Modifier Email",
        confirmEmail: "Confirmer Email",
        save: "Enregistrer les Modifications",
        cancel: "Annuler"
      },
      localization: {
        title: "Localisation",
        language: "Langue",
        country: "Pays",
        save: "Enregistrer les Modifications",
        cancel: "Annuler"
      },
      phone: {
        title: "T\xE9l\xE9phone",
        save: "Enregistrer les Modifications",
        cancel: "Annuler"
      },
      address: {
        title: "Adresse",
        save: "Enregistrer les Modifications",
        cancel: "Annuler"
      },
      profile: {
        title: "Profil",
        save: "Enregistrer les Modifications",
        cancel: "Annuler"
      },
      security: {
        home: {
          title: "Param\xE8tres de S\xE9curit\xE9",
          password: {
            label: "Mot de passe",
            description: "Changer votre mot de passe"
          },
          totp: {
            label: "Application de V\xE9rification (TOTP)",
            setupDescription: "Non Configur\xE9",
            updateDescription: "Changer votre application de v\xE9rification"
          },
          back: "Retour",
          notAvailable: "Il n'y a pas de param\xE8tres de s\xE9curit\xE9 disponibles. La s\xE9curit\xE9 de votre compte est g\xE9r\xE9e par un fournisseur tiers."
        },
        password: {
          title: "Changer Votre Mot de Passe",
          currentPassword: "Mot de Passe Actuel",
          newPassword: "Nouveau Mot de Passe",
          confirmPassword: "Confirmer le Nouveau Mot de Passe",
          continue: "Continuer",
          cancel: "Annuler",
          success: {
            title: "Mot de Passe Modifi\xE9",
            message: "Votre mot de passe a \xE9t\xE9 modifi\xE9 avec succ\xE8s. Vous devrez peut-\xEAtre vous connecter \xE0 nouveau avec votre nouveau mot de passe."
          }
        },
        totp: {
          setupTitle: "Configurer l'Application de V\xE9rification",
          setupSubtitle: "Scannez le code QR ci-dessous \xE0 l'aide de votre application d'authentification pr\xE9f\xE9r\xE9e, puis saisissez le code unique fourni ci-dessous",
          updateTitle: "Mettre \xE0 Jour l'Application de V\xE9rification",
          updateSubtitle: "Scannez le code QR ci-dessous \xE0 l'aide de votre nouvelle application d'authentification, puis saisissez le code unique fourni ci-dessous. Vous ne pourrez plus utiliser l'ancienne application d'authentification.",
          code: "Entrez le code",
          continue: "Continuer",
          cancel: "Annuler",
          success: {
            title: "Application de V\xE9rification Configur\xE9e",
            message: "Votre application de v\xE9rification a \xE9t\xE9 configur\xE9e avec succ\xE8s."
          }
        }
      },
      status: {
        backButton: "Retour au Profil"
      },
      claims: {
        profile: {
          name: "Nom Complet",
          family_name: "Nom de Famille",
          given_name: "Pr\xE9nom",
          middle_name: "Deuxi\xE8me Pr\xE9nom",
          nickname: "Surnom",
          preferred_username: "Nom d'Utilisateur",
          profile: "Profil",
          picture: "URL de l'Image de Profil",
          website: "URL du Site Web",
          gender: "Genre",
          birthdate: "Date de Naissance",
          zoneinfo: "Fuseau Horaire",
          locale: "Langue et R\xE9gion",
          updated_at: "Derni\xE8re Mise \xE0 Jour le"
        },
        email: {
          email: "Adresse Email",
          email_verified: "Email V\xE9rifi\xE9"
        },
        address: {
          address: "Adresse"
        },
        phone: {
          phone_number: "Num\xE9ro de T\xE9l\xE9phone",
          phone_number_verified: "Num\xE9ro de T\xE9l\xE9phone V\xE9rifi\xE9"
        }
      },
      errors: {
        invalidIdentityProvider: "",
        emailNotAvailable: "Email d\xE9j\xE0 utilis\xE9",
        emailConfirmationRequired: "Confirmation de l'email est requise",
        invalidEmail: "Email invalide",
        emailMismatch: "L'email de confirmation ne correspond pas",
        passwordMismatch: "Les mots de passe ne correspondent pas",
        currentPasswordRequired: "Le mot de passe actuel est requis",
        incorrectPassword: "Mot de passe incorrect",
        invalidNewPassword: "Mot de passe invalide",
        missingParameters: "",
        unableToRevokeAccess: "",
        mfaDisabled: "",
        invalidOtpCode: "Code invalide"
      }
    },
    errors: {
      serverError: {
        title: "Quelque chose n'a pas fonctionn\xE9",
        message: "Une erreur inattendue s'est produite. Veuillez contacter l'\xE9quipe d'assistance."
      },
      // OIDC provider
      invalidToken: {
        title: "Invalid Token",
        message: "The token provided is invalid."
      },
      invalidRedirectUri: {
        title: "Invalid Redirect URI",
        message: "The redirect URI provided did not match any of the client's registered redirect URIs."
      },
      invalidClientMetadata: {
        title: "Invalid Client Metadata",
        message: "The client metadata provided is invalid."
      },
      invalidScope: {
        title: "Invalid Scope",
        message: "The scope provided is invalid."
      },
      insufficientScope: {
        title: "Insufficient Scope",
        message: "The scope provided is insufficient."
      },
      invalidRequest: {
        title: "Invalid Request",
        message: "The request provided is invalid."
      },
      invalidClient: {
        title: "Invalid Application",
        message: "The application provided does not exist or could not be authenticated."
      },
      invalidGrant: {
        title: "Invalid Grant",
        message: "The grant request is invalid."
      },
      webMessageUriMismatch: {
        title: "Web Message URI Mismatch",
        message: "The web message URI provided did not match any client's registered web message URIs."
      },
      accessDenied: {
        title: "Access Denied",
        message: "Access to the requested resource is denied."
      },
      authorizationPending: {
        title: "Authorization Pending",
        message: "The authorization request is still pending as the end-user hasn't yet completed the user interaction steps."
      },
      consentRequired: {
        title: "Consent Required",
        message: "Consent is required to access the requested resource."
      },
      expiredLoginHintToken: {
        title: "Expired Login Hint Token",
        message: "The login hint token provided has expired."
      },
      expiredToken: {
        title: "Expired Token",
        message: "The token provided has expired."
      },
      interactionRequired: {
        title: "Interaction Required",
        message: "User interaction is required to access the requested resource."
      },
      invalidBindingMessage: {
        title: "Invalid Binding Message",
        message: "The binding message provided is invalid."
      },
      invalidDpopProof: {
        title: "Invalid DPoP Proof",
        message: "The DPoP proof provided is invalid."
      },
      invalidRequestObject: {
        title: "Invalid Request Object",
        message: "The request object provided is invalid."
      },
      invalidRequestUri: {
        title: "Invalid Request URI",
        message: "The request URI provided is invalid."
      },
      invalidSoftwareStatement: {
        title: "Invalid Software Statement",
        message: "The software statement provided is invalid."
      },
      invalidTarget: {
        title: "Invalid Target",
        message: "The resource indicator is missing or unknown."
      },
      invalidUserCode: {
        title: "Invalid User Code",
        message: "The user code provided is invalid."
      },
      loginRequired: {
        title: "Login Required",
        message: "Login is required to access the requested resource."
      },
      missingUserCode: {
        title: "Missing User Code",
        message: "The user code is missing."
      },
      registrationNotSupported: {
        title: "Registration Not Supported",
        message: "The registration parameter provided is not supported."
      },
      requestNotSupported: {
        title: "Request Not Supported",
        message: "The request parameter provided is not supported."
      },
      requestUriNotSupported: {
        title: "Request URI Not Supported",
        message: "The request URI parameter provided is not supported."
      },
      slowDown: {
        title: "Slow Down",
        message: "You are polling too quickly and should back off at a reasonable rate."
      },
      temporarilyUnavailable: {
        title: "Temporarily Unavailable",
        message: "The requested resource is temporarily unavailable."
      },
      transactionFailed: {
        title: "Transaction Failed",
        message: "The transaction failed."
      },
      unapprovedSoftwareStatement: {
        title: "Unapproved Software Statement",
        message: "The software statement is unapproved."
      },
      unauthorizedClient: {
        title: "Unauthorized Client",
        message: "The client is unauthorized."
      },
      unknownUserId: {
        title: "Unknown User ID",
        message: "The user ID is unknown."
      },
      unsupportedGrantType: {
        title: "Unsupported Grant Type",
        message: "The requested grant type is unsupported."
      },
      unsupportedResponseMode: {
        title: "Unsupported Response Mode",
        message: "The requested response mode is unsupported."
      },
      unsupportedResponseType: {
        title: "Unsupported Response Type",
        message: "The requested response type is unsupported."
      },
      // Server
      tenantNotReady: {
        title: "Tenant Not Ready",
        message: "The tenant you are trying to access is not currently available. This may be because it is still being set up or undergoing maintenance. Please try again later."
      },
      invalidResource: {
        title: "Invalid Resource",
        message: "The requested resource is invalid."
      },
      invalidTenant: {
        title: "Invalid Tenant",
        message: "The tenant you are trying to access does not exist. Please double-check the spelling of the tenant's name and ensure it has been properly registered."
      },
      invalidLocale: {
        title: "Invalid Language",
        message: "The requested language is not available. Please select a supported language."
      },
      invalidApplication: {
        title: "Invalid Application",
        message: "The requested application does not exist."
      },
      invalidConnector: {
        title: "Invalid Connector",
        message: "The requested connector does not exist."
      },
      invalidOperation: {
        title: "Invalid Operation",
        message: "The requested operation is invalid."
      },
      invalidInteractionSession: {
        title: "Invalid Interaction Session",
        message: "The session expired. Please try again."
      },
      // UI
      invalidView: {
        title: "Not Found",
        message: "The page you are trying to access does not exist."
      }
    }
  }
};

i18n.languages = ["en", "de", "it", "fr"];
i18n.setDefaultLocale("en", "en");
i18n.registerLanguage("en", enLanguage);
i18n.registerLanguage("de", deLanguage);
i18n.registerLanguage("it", itLanguage);
i18n.registerLanguage("fr", frLanguage);
//# sourceMappingURL=i18n.js.map
